﻿(() => {
  const config = window.KARTOLOG_TRADE_CONFIG || {};
  const tradeRoot = document.querySelector('[data-kartolog-trade-page]');
  const TRADE_API_BASE = String(config.apiBase || tradeRoot?.dataset.apiBase || '').replace(/\/$/, '');
  const TRADE_PROXY_BASE = String(config.proxyBase || '').replace(/\/$/, '');
  const TRADE_CITIES_URL = config.citiesUrl || tradeRoot?.dataset.citiesUrl || '/public/turkiye-il-ilce.json';
  const INTAKE_PRODUCT_URL = config.intakeProductUrl || tradeRoot?.dataset.intakeProductUrl || '/products/takas-sat-basvuru';
  const ACCESS_STORAGE_KEY = 'kartologTradeAccessTokens';
  const DRAFT_STORAGE_KEY = 'kartologTradeDraftState';
  const SHOPIFY_CUSTOMER = {
    ...(config.customer || {}),
    loggedIn: Boolean(config.customer?.loggedIn) || tradeRoot?.dataset.customerLoggedIn === 'true',
    name: config.customer?.name || tradeRoot?.dataset.customerName || '',
    email: config.customer?.email || tradeRoot?.dataset.customerEmail || '',
    phone: config.customer?.phone || tradeRoot?.dataset.customerPhone || '',
    address1: config.customer?.address1 || tradeRoot?.dataset.customerAddress1 || '',
    address2: config.customer?.address2 || tradeRoot?.dataset.customerAddress2 || '',
    city: config.customer?.city || tradeRoot?.dataset.customerCity || '',
    district: config.customer?.district || tradeRoot?.dataset.customerDistrict || '',
    zip: config.customer?.zip || tradeRoot?.dataset.customerZip || '',
  };
  const apiPath = (pathname) => TRADE_API_BASE ? TRADE_API_BASE + pathname : pathname;
  const customerApiPath = (pathname) => TRADE_PROXY_BASE ? TRADE_PROXY_BASE + pathname : apiPath(pathname);
  async function readJsonResponse(response, fallbackMessage = 'Sunucu cevabı okunamadı.') {
    const text = await response.text();
    if (!text) return {};
    try {
      return JSON.parse(text);
    } catch {
      const looksHtml = /^\s*</.test(text);
      throw new Error(looksHtml ? fallbackMessage : 'Sunucu JSON cevabı okunamadı.');
    }
  }

      const VALUE_MULTIPLIER = 1.3;
      const state = { mode: 'trade', shippingRequestId: '', editingRequestId: '', selectedOperationId: '', lastTrackedRequest: null, desiredResults: [], offeredResults: [], desired: [], offered: [], cities: [], pokemonSets: [], tradeLocationName: '', operations: [] };
      const els = {
        form: document.getElementById('trade-form'),
        layout: document.getElementById('page-layout'),
        modeHelper: document.getElementById('mode-helper'),
        modeButtons: [...document.querySelectorAll('[data-mode]')],
        desiredSection: document.getElementById('desired-section'),
        offerSearchSection: document.getElementById('offer-search-section'),
        summaryDesiredSection: document.getElementById('summary-desired-section'),
        desiredForm: document.getElementById('desired-search-form'),
        desiredSearch: document.getElementById('desired-search'),
        desiredClear: document.getElementById('desired-clear'),
        desiredResults: document.getElementById('desired-results'),
        desiredPicked: document.getElementById('desired-picked'),
        desiredCount: document.getElementById('desired-count'),
        searchForm: document.getElementById('search-form'),
        search: document.getElementById('search'),
        offerSetSearch: document.getElementById('offer-set-search'),
        offerSetOptions: document.getElementById('offer-set-options'),
        offerClear: document.getElementById('offer-clear'),
        city: document.getElementById('city'),
        district: document.getElementById('district'),
        results: document.getElementById('results'),
        resultCount: document.getElementById('result-count'),
        picked: document.getElementById('picked'),
        pickedCount: document.getElementById('picked-count'),
        summaryTitle: document.getElementById('summary-title'),
        summaryPanel: document.getElementById('summary-panel'),
        summaryTotals: document.getElementById('summary-totals'),
        offeredSummaryHead: document.getElementById('offered-summary-head'),
        desiredTotalBox: document.getElementById('desired-total-box'),
        offerTotalLabel: document.getElementById('offer-total-label'),
        desiredTotal: document.getElementById('desired-total'),
        offerTotal: document.getElementById('offer-total'),
        balanceStatus: document.getElementById('balance-status'),
        balanceDifference: document.getElementById('balance-difference'),
        balanceBarFill: document.getElementById('balance-bar-fill'),
        balanceMessage: document.getElementById('balance-message'),
        balanceCard: document.getElementById('balance-card'),
        summaryHint: document.getElementById('summary-hint'),
        summaryText: document.getElementById('summary-text'),
        approvedRequestId: document.getElementById('approved-request-id'),
        approvedShippingBox: document.getElementById('approved-shipping-box'),
        operationShippingFormSlot: document.getElementById('operation-shipping-form-slot'),
        operationsSection: document.getElementById('operations-section'),
        contactFields: document.getElementById('contact-fields'),
        flowNotice: document.getElementById('flow-notice'),
        status: document.getElementById('status'),
        success: document.getElementById('success'),
        trackingForm: document.getElementById('tracking-form'),
        refreshOperations: document.getElementById('refresh-operations'),
        operationsList: document.getElementById('operations-list'),
        operationsSearch: document.getElementById('operations-search'),
        operationsStatusFilter: document.getElementById('operations-status-filter'),
        operationsSort: document.getElementById('operations-sort'),
        opsStatTotal: document.getElementById('ops-stat-total'),
        opsStatReview: document.getElementById('ops-stat-review'),
        opsStatShipping: document.getElementById('ops-stat-shipping'),
        opsStatCompleted: document.getElementById('ops-stat-completed'),
        trackingResult: document.getElementById('tracking-result'),
        submit: document.getElementById('submit'),
      };
      const summaryPanelHome = els.summaryPanel?.parentNode || null;
      const summaryPanelNextSibling = els.summaryPanel?.nextSibling || null;

      function restoreSummaryPanelHome() {
        if (!els.summaryPanel || !summaryPanelHome || els.summaryPanel.parentNode === summaryPanelHome) return;
        if (summaryPanelNextSibling && summaryPanelNextSibling.parentNode === summaryPanelHome) {
          summaryPanelHome.insertBefore(els.summaryPanel, summaryPanelNextSibling);
        } else {
          summaryPanelHome.appendChild(els.summaryPanel);
        }
      }

      function moveSummaryPanelToOperationDetail() {
        if (!els.summaryPanel || !els.operationShippingFormSlot) return;
        if (els.summaryPanel.parentNode !== els.operationShippingFormSlot) {
          els.operationShippingFormSlot.appendChild(els.summaryPanel);
        }
      }

      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
      }
      function createLineId(prefix = 'line') {
        return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      }
      function asSingleCardLine(card, prefix = 'line', index = 0) {
        return { ...card, quantity: 1, _lineId: card?._lineId || card?.lineId || `${prefix}-${index}-${createLineId()}` };
      }
      function expandQuantityCards(cards = [], prefix = 'line') {
        return cards.flatMap((card, index) => {
          const quantity = Math.max(1, Number(card?.quantity || 1) || 1);
          return Array.from({ length: quantity }, (_unused, quantityIndex) => asSingleCardLine(card, prefix, `${index}-${quantityIndex}`));
        });
      }
      function draftKey(requestId = state.editingRequestId) {
        return String(requestId || '').trim().toUpperCase();
      }
      function readDraftStore() {
        try { return JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}') || {}; } catch { return {}; }
      }
      function writeDraftStore(store) {
        localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(store || {}));
      }
      function slimCardForDraft(card, keepImages = true) {
        const copy = { ...card };
        if (!keepImages) {
          delete copy.frontImageBase64;
          delete copy.backImageBase64;
        }
        return copy;
      }
      function saveActiveDraft() {
        const key = draftKey();
        if (!key) return;
        const store = readDraftStore();
        store[key] = {
          updatedAt: new Date().toISOString(),
          tradeLocationName: state.tradeLocationName || '',
          desired: state.desired.map((card) => slimCardForDraft(card)),
          offered: state.offered.map((card) => slimCardForDraft(card)),
        };
        try {
          writeDraftStore(store);
        } catch {
          store[key].desired = state.desired.map((card) => slimCardForDraft(card, false));
          store[key].offered = state.offered.map((card) => slimCardForDraft(card, false));
          try { writeDraftStore(store); } catch {}
        }
      }
      function loadSavedDraft(requestId) {
        return readDraftStore()[draftKey(requestId)] || null;
      }
      function hasSavedDraft(requestId) {
        return Object.prototype.hasOwnProperty.call(readDraftStore(), draftKey(requestId));
      }
      function savedDraftIsFresh(saved, request) {
        if (!saved) return false;
        const savedTime = Date.parse(saved.updatedAt || '');
        const requestTime = Date.parse(request?.updatedAt || '');
        if (!Number.isFinite(savedTime)) return false;
        if (!Number.isFinite(requestTime)) return true;
        return savedTime >= requestTime;
      }
      function clearSavedDraft(requestId) {
        const key = draftKey(requestId);
        if (!key) return;
        const store = readDraftStore();
        delete store[key];
        try { writeDraftStore(store); } catch {}
      }
      function cardKey(card) {
        return String(card?._lineId || card?.lineId || card?.variantId || card?.productId || card?.id || card?.pricechartingId || [card?.title, card?.setName, card?.number].join('|')).toLowerCase();
      }
      function mergeCards(primary = [], secondary = []) {
        const map = new Map();
        [...primary, ...secondary].forEach((card) => {
          const key = cardKey(card);
          if (!key) return;
          map.set(key, { ...(map.get(key) || {}), ...card });
        });
        return [...map.values()];
      }
      function normalizePhone(value) {
        let digits = String(value || '').replace(/[^0-9]/g, '');
        if (digits.startsWith('90') && digits.length === 12) digits = digits.slice(2);
        while (digits.startsWith('0')) digits = digits.slice(1);
        return digits.slice(0, 10);
      }
      function normalizeAddressText(value) {
        return String(value || '').toLocaleLowerCase('tr-TR').replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's').replace(/ö/g, 'o').replace(/ç/g, 'c').replace(/[^a-z0-9]+/g, ' ').trim();
      }
      function setFieldIfEmpty(name, value) {
        const field = els.form?.elements?.[name];
        if (!field || field.value || !String(value || '').trim()) return;
        field.value = String(value || '').trim();
      }
      function setSelectByLooseText(select, value) {
        const target = normalizeAddressText(value);
        if (!select || !target) return false;
        const option = [...select.options].find((entry) => normalizeAddressText(entry.value) === target || normalizeAddressText(entry.textContent) === target);
        if (!option) return false;
        select.value = option.value;
        return true;
      }
      function autofillShopifyCustomerFields() {
        if (!SHOPIFY_CUSTOMER.loggedIn) return;
        setFieldIfEmpty('name', SHOPIFY_CUSTOMER.name);
        setFieldIfEmpty('email', SHOPIFY_CUSTOMER.email);
        setFieldIfEmpty('phone', normalizePhone(SHOPIFY_CUSTOMER.phone));
        setFieldIfEmpty('address1', [SHOPIFY_CUSTOMER.address1, SHOPIFY_CUSTOMER.address2].filter(Boolean).join(' '));
        setFieldIfEmpty('postalCode', SHOPIFY_CUSTOMER.zip);
        if (setSelectByLooseText(els.city, SHOPIFY_CUSTOMER.city)) {
          renderDistricts();
          setSelectByLooseText(els.district, SHOPIFY_CUSTOMER.district);
        }
      }
      function storedAccessTokens() {
        try {
          const parsed = JSON.parse(localStorage.getItem(ACCESS_STORAGE_KEY) || '{}');
          return parsed && typeof parsed === 'object' ? parsed : {};
        } catch {
          return {};
        }
      }
      function rememberAccessToken(requestId, accessToken) {
        if (!requestId || !accessToken) return;
        const tokens = storedAccessTokens();
        tokens[requestId] = accessToken;
        localStorage.setItem(ACCESS_STORAGE_KEY, JSON.stringify(tokens));
      }
      function accessTokenForRequest(requestId) {
        return storedAccessTokens()[requestId] || '';
      }
      function allAccessTokens() {
        return Object.values(storedAccessTokens()).filter(Boolean);
      }
      function usdTryRate(item) {
        const rate = Number(item.usdTryRate || item.usdTryRateUsed || item.pricing?.usdTryRate || 0);
        return Number.isFinite(rate) && rate > 0 ? rate : 0;
      }
      function parsePcUsd(value) {
        const raw = String(value || '').trim();
        if (!raw) return 0;
        const numeric = Number(raw.replace(/[^0-9.-]/g, ''));
        if (!Number.isFinite(numeric) || numeric <= 0) return 0;
        return /[.,$]/.test(raw) ? numeric : numeric / 100;
      }
      function pcUsdValue(item) {
        return parsePcUsd(item.rawLoosePrice);
      }
      function pcValueTry(item) {
        const sitePrice = Number(String(item.price || '').replace(',', '.'));
        if (Number.isFinite(sitePrice) && sitePrice > 0) return Math.round((sitePrice / 1.8) * 100) / 100;
        const usd = pcUsdValue(item);
        const rate = usdTryRate(item);
        if (usd > 0 && rate > 0) return Math.round(usd * rate * 100) / 100;
        const estimated = Number(item.estimatedValue || 0);
        const quantity = Math.max(1, Number(item.quantity || 1));
        return Number.isFinite(estimated) && estimated > 0 ? estimated / quantity : 0;
      }
      function rawGradeValue(item, grade) {
        const key = String(grade || '').replace(/\s+/g, '').toUpperCase();
        const raw = parsePcUsd(item.gradePrices?.[key]);
        const rate = usdTryRate(item);
        return raw > 0 && rate > 0 ? Math.round(raw * rate * 100) / 100 : 0;
      }
      function pcValueForCondition(item) {
        const condition = String(item.condition || '').toUpperCase().replace(/\s+/g, ' ');
        if (condition === 'PSA 10') return rawGradeValue(item, 'PSA10') || pcValueTry(item);
        if (condition === 'PSA 9') return rawGradeValue(item, 'PSA9') || pcValueTry(item);
        if (condition === 'PSA 8') return rawGradeValue(item, 'PSA8') || pcValueTry(item);
        return pcValueTry(item);
      }
      function tradeValue(item) { return Math.round(pcValueTry(item) * VALUE_MULTIPLIER * Number(item.quantity || 1) * 100) / 100; }
      function isJapaneseCard(item) { return /\bjapanese\b/i.test([item.title, item.productName, item.setName, item.consoleName].join(' ')); }
      function isExCard(item) { return /\bex\b/i.test([item.title, item.productName].join(' ')); }
      function isBulkRejected(item) { return /\bbulk\b/i.test([item.title, item.productName, item.setName, item.consoleName, item.kind].join(' ')); }
      function numericCardNumber(value) {
        const match = String(value || '').match(/(\d+)/);
        return match ? Number(match[1]) : 0;
      }
      function printedTotalFromText(item) {
        const match = [item.title, item.productName, item.number].join(' ').match(/\b\d+\s*\/\s*(\d+)\b/);
        return match ? Number(match[1]) : 0;
      }
      function isAbovePrintedSetTotal(item) {
        const number = numericCardNumber(item.number || item.title || item.productName);
        const setTotal = Number(item.setPrintedTotal || printedTotalFromText(item) || 0);
        if (!Number.isFinite(number) || number <= 0) return false;
        if (Number.isFinite(setTotal) && setTotal > 0) return number > setTotal;
        return number >= 190;
      }
      function sellRule(item) {
        if (isBulkRejected(item)) return { accepted: false, multiplier: 0, label: 'Bulk kart kabul edilmiyor.' };
        if (isExCard(item)) return { accepted: true, manualPricing: true, multiplier: isJapaneseCard(item) ? 0.8 : 0.9, label: 'Modern EX kartlar genelde kabul edilmez. İnceleme için ekleyebilirsin; kartın değerine göre teklif PC değerine kadar çıkabilir.' };
        if (isJapaneseCard(item)) return { accepted: true, multiplier: 0.8, label: 'Japonca kart: PC x 0.8' };
        return { accepted: true, multiplier: 0.9, label: 'İngilizce kart: PC x 0.9' };
      }
      function sellValue(item) { const rule = sellRule(item); return rule.accepted ? Math.round(pcValueForCondition(item) * rule.multiplier * Number(item.quantity || 1) * 100) / 100 : 0; }
      function offerValue(item) { return state.mode === 'trade-shipping' ? tradeValue(item) : sellValue(item); }
      function money(value) { return '₺' + Number(value || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
      const SHIPPING_AGREEMENT_VERSION = 'trade-shipping-agreement-v3';
      const SHIPPING_AGREEMENT_MERCHANT = {
        title: 'Berke TEZİÇ',
        address: 'Erenköy Mah. Tellikavak Sok. No:25/C Kadıköy İstanbul',
        email: 'kartologtube@gmail.com',
        phone: '0532 137 68 76',
        website: 'www.kartolog.com',
      };
      const SHIPPING_AGREEMENT_BODY_TEXT = `
2. Sözleşmenin Konusu

İşbu sözleşmenin konusu, müşterinin Kartolog'a ait takas başvuru ürününü satın alarak başlattığı kart takas sürecinin şartlarını belirlemektir.

Bu süreç kapsamında müşteri;

1. Kartolog Takas Başvuru Ürünü'nü satın alır.
2. Takas başvuru formunu doldurur.
3. Takas olarak almak istediği kartları takas sepetine ekler.
4. Kartolog'a göndermek istediği kartları başvuruya ekler.
5. Kartolog tarafından yapılacak ilk değerlendirme ve nihai değerlendirme sonucunda teklif alır.
6. Teklifi kabul etmesi halinde takas işlemi tamamlanır.
7. Teklifi kabul etmemesi veya işlemden vazgeçmesi halinde kart iadesi süreci uygulanır.

3. Takas Başvuru Ürünü ve Bedel Yapısı

Kartolog Takas Başvuru Ürünü, takas başvurusunu başlatmak için kullanılan bir başvuru ürünüdür.

Bu ürünün toplam bedeli aşağıdaki kalemlerden oluşmaktadır:

200 TL - İlk gönderim kargo bedeli
Müşterinin takasa konu kartlarını Kartolog'a göndermesi için kullanılacak kargo bedelidir.

200 TL - İşlem ve değerlendirme bedeli
Kartların tarafımıza gönderilmesinden sonra müşterinin işlemden vazgeçmesi veya nihai teklifi kabul etmemesi halinde, başvurunun açılması, ön kontrol, operasyon ve değerlendirme süreçleri için alınacak hizmet bedelidir.

200 TL - İade kargo bedeli
Kartların Kartolog'a ulaştıktan sonra müşterinin işlemden vazgeçmesi veya nihai teklifi kabul etmemesi halinde, müşteriye geri gönderilecek kartlar için kullanılacak iade kargo bedelidir.

Takas işleminin olumlu sonuçlanması ve müşteri tarafından onaylanması halinde, yalnızca ilk gönderim için kullanılan 200 TL kargo bedeli düşülür. Kalan 400 TL, müşterinin Kartolog hesabına mağaza kredisi olarak yüklenir.

4. Takas Sepeti ve Gönderilecek Kartların Seçilmesi

Müşteri, takas olarak almak istediği kartları, ilgili kartların ürün sayfasında yer alan "Takasa Ekle" butonunu kullanarak takas sepetine ekleyebilir.

Müşteri, Kartolog'a göndermek istediği kartları başvuru formunda belirtir. Müşteri tarafından gönderilecek kartların toplam tahmini değerinin, takas olarak talep edilen kartların toplam değerini karşılaması gerekir.

Kart fiyatları piyasa koşullarına, stok durumuna, kart kondisyonuna, kur değişimlerine ve Kartolog değerlendirmesine göre değişebilir. Bu nedenle müşterinin, göndereceği kartların toplam tahmini değerini takas olarak almak istediği kartların değerine eşit veya mümkünse bir miktar üzerinde tutması önerilir.

Gönderilen kartların nihai değerlendirme sonucunda takas için gerekenden daha yüksek değerde olması halinde, aradaki fazla tutar müşterinin Kartolog hesabına mağaza kredisi olarak yüklenebilir.

Müşteri, fazla tutarın mağaza kredisi olarak tanımlanabilmesi ve Kartolog'a gönderilen kartların stok girişlerinin yapılabilmesi için gerekli bilgileri doğru ve eksiksiz şekilde paylaşmayı kabul eder.

5. İlk Değerlendirme ve Ön Teklif

Müşteri başvurusunu tamamladıktan sonra Kartolog, başvuruda belirtilen kartları ve müşterinin takas olarak almak istediği kartları ön değerlendirmeye alır.

Bu aşamada verilen teklif, müşterinin beyan ettiği kart bilgilerine ve görsellerine göre oluşturulan ön teklif niteliğindedir.

Ön teklif; kartların gerçek kondisyonu, orijinalliği, baskı dili, nadirliği, piyasa fiyatı, stok durumu ve Kartolog'un ticari değerlendirmesine göre değişebilir.

Kartolog, herhangi bir başvuruyu gerekçe göstermeksizin reddetme, ek bilgi veya ek görsel talep etme hakkını saklı tutar.

6. Müşterinin Ön Teklifi Onaylaması ve Kargo Süreci

Müşteri, Kartolog tarafından iletilen ön teklifi kabul ederse, Kartolog tarafından yönlendirilen kargo sürecini takip ederek kartlarını Kartolog'a gönderir.

Müşteri, kartları kargoya verirken kartların zarar görmeyecek şekilde paketlenmesinden sorumludur. Kartların sleeve, toploader, kart koruyucu veya benzeri uygun koruma malzemeleriyle gönderilmesi önerilir.

Kargo sürecinde oluşabilecek gecikme, hasar, kayıp veya eksik teslimat gibi durumlarda kargo firmasının taşıma şartları uygulanır. Kartolog, kendisine eksiksiz ve hasarsız şekilde ulaşmayan kartlardan sorumlu değildir.

Müşteri, gönderdiği kartların kendisine ait olduğunu, kartlar üzerinde üçüncü kişilere ait hak, rehin, haciz, ihtilaf veya mülkiyet iddiası bulunmadığını kabul ve beyan eder.

7. Kartların Kartolog'a Ulaşması ve Nihai İnceleme

Kartlar Kartolog'a ulaştıktan sonra Kartolog ekibi tarafından fiziksel inceleme yapılır.

Bu incelemede özellikle aşağıdaki kriterler dikkate alınır:

- Kartın orijinalliği
- Kartın kondisyonu
- Ön ve arka yüz durumu
- Çizik, ezik, kırık, bükülme, soyulma, leke, baskı hatası veya sıvı teması
- Dil, set, seri, nadirlik ve varyant bilgisi
- Piyasa değeri ve güncel satış durumu
- Kartolog'un mevcut stok ve alım kriterleri

Kartolog, fiziksel inceleme sonucunda ön teklifi aynen onaylayabilir, yeni bir fiyat teklifi sunabilir veya başvuruyu reddedebilir.

8. Yeni Teklif, Müşteri Onayı ve Vazgeçme Hakkı

Fiziksel inceleme sonucunda kartların değeri ön tekliften farklı çıkarsa Kartolog müşteriye yeni bir teklif iletir.

Müşteri bu yeni teklifi kabul ederse takas işlemi tamamlanır ve takas olarak seçilen kartlar müşteriye gönderilir.

Müşteri yeni teklifi kabul etmezse veya işlemden vazgeçerse, müşterinin Kartolog'a gönderdiği kartlar iade edilir.

Bu durumda, başvuru bedeli içinde yer alan işlem/değerlendirme bedeli ve iade kargo bedeli, süreçte kullanılmış sayılır. Varsa kullanılmayan veya iadesi gereken tutarlar Kartolog tarafından müşteriye iade edilebilir veya müşterinin onayıyla mağaza kredisi olarak tanımlanabilir.

9. Takasın Tamamlanması

Müşteri nihai teklifi onayladıktan sonra, takas olarak seçilen kart veya kartlar Kartolog tarafından müşteriye gönderilir.

Takas işlemi tamamlandığında, taraflar karşılıklı edimlerini yerine getirmiş kabul edilir.

Takas sonucunda müşterinin lehine fazla bakiye oluşması halinde, bu tutar müşterinin Kartolog hesabına mağaza kredisi olarak yüklenebilir.

Mağaza kredisi nakit olarak ödenmez. Kartolog üzerinde yapılacak sonraki alışverişlerde kullanılabilir.

Takas kapsamında Kartolog'a gönderilen ve Kartolog tarafından kabul edilen kartlar, Kartolog stoklarına alınabilir. Bu stok girişleri ve oluşabilecek mağaza kredisi işlemleri için gerekli muhasebe kayıtları Kartolog tarafından tutulabilir.

10. Kartolog'un Takas Kartlarını Satın Alma veya Reddetme Hakkı

Kartolog, müşterinin gönderdiği kartları satın almak, takasa kabul etmek veya reddetmek konusunda serbesttir.

Aşağıdaki durumlarda Kartolog başvuruyu reddedebilir:

- Kartların başvuruda belirtilenden farklı çıkması
- Kartların sahte, şüpheli veya doğrulanamaz olması
- Kart kondisyonunun beyan edilenden düşük olması
- Kartlarda ciddi hasar, eksik bilgi veya yanıltıcı beyan bulunması
- Kartların Kartolog alım kriterlerine uygun olmaması
- Piyasa fiyatlarında ciddi değişiklik yaşanması
- Takas olarak istenen kartın stoktan çıkması veya satılmış olması

Bu hallerde Kartolog müşteriye bilgi verir ve süreç müşterinin tercihine göre iade veya yeni teklif üzerinden ilerletilir.

11. Stok ve Fiyat Değişiklikleri

Takas süreci boyunca kart fiyatları ve stok durumu değişebilir.

Müşterinin takas sepetine eklediği kartlar, Kartolog tarafından ayrıca rezerve edilmediği sürece kesin olarak müşteriye ayrılmış sayılmaz.

Kartolog, sürecin başında müşteriye ön teklif verirken takas olarak istenen kartların stok durumunu dikkate alır. Ancak süreç içinde ilgili kartın satılması, stoktan çıkması veya fiyatının değişmesi halinde müşteriye alternatif kart, mağaza kredisi veya yeni teklif sunulabilir.

12. Cayma ve İptal Şartları

Müşteri, takas başvurusunu oluşturduktan sonra, kartlarını Kartolog'a göndermeden önce başvurudan vazgeçebilir.

Kartlar Kartolog'a gönderildikten sonra müşterinin işlemden vazgeçmesi halinde, başvuru kapsamında fiilen başlayan hizmet, operasyon, ön inceleme, kart kabul süreci ve kargo süreçleri dikkate alınarak işlem/değerlendirme bedeli ve varsa kargo bedelleri mahsup edilebilir.

Müşteri, nihai teklifi kabul etmezse kartlarının kendisine iade edilmesini talep edebilir. Bu durumda iade kargo süreci başlatılır.

Müşteri, işbu sözleşmeyi onaylayarak takas başvuru hizmetinin, başvuru sonrası Kartolog tarafından işleme alınacağını ve kartların gönderilmesiyle birlikte operasyonel sürecin başlayacağını kabul eder.

13. Kargo, Paketleme ve Teslimat Sorumluluğu

Müşteri, Kartolog'a göndereceği kartları güvenli şekilde paketlemekle yükümlüdür.

Kartların kargoda zarar görmemesi için aşağıdaki paketleme yöntemleri önerilir:

- Kartların sleeve içine konulması
- Kartların toploader ile gönderilmesi
- Kartların hareket etmeyecek şekilde sabitlenmesi
- Sıvı, ezilme ve bükülmeye karşı korumalı paket kullanılması
- Paket içine başvuru numarası veya müşteri bilgisi eklenmesi

Kartolog'a ulaşmadan önce kargoda oluşabilecek hasar, kayıp, eksik teslimat veya gecikmelerden Kartolog sorumlu değildir.

Kartolog tarafından müşteriye gönderilen kartlarda ise gönderim, Kartolog'un anlaşmalı kargo süreçleri üzerinden yapılır.

14. Sahte, Şüpheli veya Uygunsuz Kartlar

Kartolog, sahte, değiştirilmiş, baskı müdahalesi yapılmış, şüpheli, çalıntı olduğu düşünülen veya orijinalliği doğrulanamayan kartları takasa kabul etmeme hakkına sahiptir.

Bu tür durumlarda Kartolog, işlemi durdurabilir, müşteriden ek açıklama veya belge talep edebilir ve gerekli gördüğü hallerde kartları iade edebilir.

Kartolog, hukuka aykırı olduğu değerlendirilen işlemleri reddetme hakkını saklı tutar.

15. Mağaza Kredisi Kullanımı

Takas işlemi sonucunda müşterinin lehine bakiye oluşması veya başvuru bedelinden mağaza kredisi tanımlanması halinde, ilgili tutar müşterinin Kartolog hesabına mağaza kredisi olarak yüklenir.

Mağaza kredisi yalnızca Kartolog üzerinden yapılacak alışverişlerde kullanılabilir.

Mağaza kredisi nakde çevrilemez, üçüncü kişilere devredilemez ve Kartolog tarafından belirlenen kullanım koşullarına tabidir.

Müşteri, mağaza kredisi tanımlanabilmesi için Kartolog tarafından talep edilen kimlik ve iletişim bilgilerinin doğru ve eksiksiz olması gerektiğini kabul eder.

16. Kişisel Veriler, T.C. Kimlik Numarası ve Gider Pusulası Bilgilendirmesi

Müşteri, takas başvurusu kapsamında ad, soyad, T.C. kimlik numarası, adres, telefon, e-posta, sipariş bilgileri, kargo bilgileri ve başvuruya konu kart bilgileri gibi kişisel verilerinin Kartolog tarafından işlenebileceğini kabul eder.

Müşterinin T.C. kimlik numarası; takas işlemi sonucunda oluşabilecek mağaza kredilerinin müşteri hesabına doğru şekilde tanımlanması, müşteri tarafından Kartolog'a gönderilen kartların stok girişlerinin yapılması, muhasebe kayıtlarının oluşturulması ve gerekli hallerde gider pusulası düzenlenmesi amacıyla alınmaktadır.

Kartolog, müşteriden alınan kişisel verileri yalnızca takas başvuru sürecinin yürütülmesi, müşteri iletişimi, kargo işlemleri, mağaza kredisi tanımlamaları, stok ve muhasebe kayıtları, gider pusulası düzenlenmesi ve yasal yükümlülüklerin yerine getirilmesi amacıyla işler.

Müşteri, Kartolog'a gönderdiği kartların takasa kabul edilmesi, satın alınması veya Kartolog stoklarına alınması halinde, ilgili kartların stok girişleri ve muhasebe kayıtları için gerekli bilgilerin kullanılabileceğini kabul eder.

Gerekli hallerde, Kartolog tarafından müşterinin gönderdiği kartlara ilişkin gider pusulası veya benzeri yasal/muhasebesel belgeler düzenlenebilir. Müşteri, bu belgelerin düzenlenebilmesi için T.C. kimlik numarası dahil gerekli bilgilerin Kartolog tarafından kullanılabileceğini kabul eder.

Kartolog, kişisel verileri ilgili mevzuata uygun şekilde işler, korur ve yasal zorunluluklar dışında üçüncü kişilerle paylaşmaz.

17. Müşteri Beyan ve Taahhütleri

Müşteri;

1. Başvuru formunda verdiği bilgilerin doğru olduğunu,
2. T.C. kimlik numarası dahil kimlik ve iletişim bilgilerinin doğru ve eksiksiz olduğunu,
3. Gönderdiği kartların kendisine ait olduğunu,
4. Kartların orijinalliği ve kondisyonu hakkında yanıltıcı bilgi vermeyeceğini,
5. Kartların güvenli şekilde paketlenmesinden sorumlu olduğunu,
6. Kartolog tarafından yapılacak nihai değerlendirmenin fiziksel inceleme sonucuna göre değişebileceğini,
7. Ön teklifin kesin alım veya kesin takas garantisi anlamına gelmediğini,
8. Nihai teklifi kabul etmemesi halinde iade sürecinin uygulanacağını,
9. Takas sürecinde fiyat ve stok değişiklikleri yaşanabileceğini,
10. Fazla tutarın uygun hallerde mağaza kredisi olarak tanımlanabileceğini,
11. T.C. kimlik numarasının; takas işlemi sonucunda oluşabilecek mağaza kredilerinin tanımlanması, gönderilen kartların stok girişlerinin yapılması, muhasebe kayıtlarının oluşturulması ve gerekli hallerde gider pusulası düzenlenmesi amacıyla alındığını bildiğini,
12. Kartolog'a gönderdiği kartların takasa kabul edilmesi, satın alınması veya stok girişinin yapılması halinde, bu işlemle ilgili muhasebe ve kayıt süreçlerinin yürütülebilmesi için gerekli bilgileri doğru ve eksiksiz şekilde paylaşacağını,
13. Gider pusulası veya benzeri yasal/muhasebesel belgelerin düzenlenmesi gereken hallerde, Kartolog'un bu belgeleri düzenleyebilmesi için gerekli bilgileri kullanabileceğini,
14. İşbu sözleşmeyi okuyup anladığını ve elektronik ortamda onayladığını

kabul, beyan ve taahhüt eder.

18. Uyuşmazlıkların Çözümü

İşbu sözleşmeden doğabilecek uyuşmazlıklarda, yürürlükteki mevzuat hükümleri uygulanır.

Tüketici niteliğindeki müşteriler bakımından, ilgili mevzuatta belirtilen parasal sınırlar dahilinde tüketici hakem heyetleri ve tüketici mahkemeleri yetkilidir.

19. Yürürlük

İşbu sözleşme, müşteri tarafından elektronik ortamda onaylandığı tarihte yürürlüğe girer.

Müşteri, Kartolog Takas Başvuru Ürünü'nü satın alarak ve başvuru formunu onaylayarak işbu sözleşmenin tüm hükümlerini kabul etmiş sayılır.

ONAY METNİ

Müşteri olarak;

- Kartolog Takas Başvuru ve Değerlendirme Sözleşmesi'ni okuduğumu,
- Takas başvuru sürecinin ön teklif ve nihai teklif aşamalarından oluştuğunu,
- Kartlar fiziksel olarak incelendikten sonra teklifin değişebileceğini,
- Takas işlemi olumlu sonuçlanırsa kalan tutarın mağaza kredisi olarak tanımlanabileceğini,
- İşlemden vazgeçmem halinde kargo ve işlem/değerlendirme bedellerinin uygulanabileceğini,
- Mağaza kredisinin nakit olarak ödenmeyeceğini,
- Kartların güvenli paketlenmesinden ve doğru beyan edilmesinden sorumlu olduğumu,
- T.C. kimlik numaramın; mağaza kredisi tanımlanması, tarafımdan gönderilen kartların stok girişlerinin yapılması, muhasebe kayıtlarının oluşturulması ve gerekli hallerde gider pusulası düzenlenmesi amacıyla alınacağını ve işleneceğini

kabul ediyorum.
`.trim();
      const SHIPPING_AGREEMENT_BODY = SHIPPING_AGREEMENT_BODY_TEXT.split(/\n{2,}/);
      function restoreRawLoosePrice(item, valueMultiplier = null) {
        if (Number(item.rawLoosePrice || 0) > 0 || !Number(item.estimatedValue || 0)) return item;
        const quantity = Math.max(1, Number(item.quantity || 1));
        const rule = sellRule(item);
        const multiplier = valueMultiplier || (rule.accepted && rule.multiplier > 0 ? rule.multiplier : 1);
        const rate = usdTryRate(item) || 1;
        return { ...item, rawLoosePrice: Math.round((Number(item.estimatedValue || 0) / quantity / multiplier / rate) * 100) };
      }
      function withDistributedEstimatedValue(items, total) {
        const quantityTotal = items.reduce((sum, item) => sum + Math.max(1, Number(item.quantity || 1)), 0);
        const perCard = quantityTotal && Number(total || 0) > 0 ? Number(total) / quantityTotal : 0;
        return items.map((item) => Number(item.estimatedValue || 0) > 0 ? item : { ...item, estimatedValue: perCard * Math.max(1, Number(item.quantity || 1)) });
      }
      function offeredCardsPayload() {
        return state.offered.map((item) => ({
          ...item,
          lineId: item.lineId || item._lineId || createLineId('offered'),
          quantity: 1,
          estimatedValue: offerValue({ ...item, quantity: 1 }),
          manualPricing: Boolean(sellRule(item).manualPricing),
        }));
      }
      let offeredSyncTimer = null;
      async function syncOfferedCardsToBackend() {
        if (!TRADE_PROXY_BASE || !state.editingRequestId) return null;
        const response = await fetch(customerApiPath('/trade-draft-api/offered-cards'), {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            requestId: state.editingRequestId,
            offeredCards: offeredCardsPayload(),
          }),
        });
        const data = await readJsonResponse(response, 'Gönderilecek kartlar kaydedilemedi.');
        if (!response.ok || !data.ok) throw new Error(data.error || 'Gönderilecek kartlar kaydedilemedi.');
        return data.request || null;
      }
      async function saveOfferedCardsForRequest(requestId, offeredCards) {
        if (!TRADE_PROXY_BASE || !requestId) throw new Error('Fotoğraf kaydı için Shopify oturumu gerekli.');
        const response = await fetch(customerApiPath('/trade-draft-api/offered-cards'), {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ requestId, offeredCards }),
        });
        const data = await readJsonResponse(response, 'Fotoğraflar kaydedilemedi.');
        if (!response.ok || !data.ok) throw new Error(data.error || 'Fotoğraflar kaydedilemedi.');
        return data.request || null;
      }
      function queueOfferedCardsSync() {
        if (!TRADE_PROXY_BASE || !state.editingRequestId) return;
        window.clearTimeout(offeredSyncTimer);
        offeredSyncTimer = window.setTimeout(() => {
          syncOfferedCardsToBackend()
            .then(() => setStatus('Taslak kaydedildi.', 'ok'))
            .catch((error) => setStatus(error.message || 'Taslak kaydedilemedi.', 'error'));
        }, 450);
      }
      function meta(item) {
        const valueText = state.mode === 'sell' || state.mode === 'trade'
          ? sellRule(item).label + (sellRule(item).accepted && pcValueForCondition(item) ? ' · Değer: ' + money(sellValue({ ...item, quantity: 1 })) : '')
          : (pcValueTry(item) ? 'Takas: ' + money(pcValueTry(item) * VALUE_MULTIPLIER) : 'PC değeri yok');
        return [item.setName, item.number ? '#' + item.number : '', item.variant || '', item.locationName ? 'Lokasyon: ' + item.locationName : '', item.pricechartingId ? 'PC ' + item.pricechartingId : '', valueText, item.kind].filter(Boolean).join(' · ');
      }
      function displayTitle(item) {
        return item.variant ? `${item.title} (${item.variant})` : item.title;
      }
      function cardInfoLine(item) {
        return [item.setName, item.number ? '#' + item.number : '', item.variant || '', item.locationName ? 'Lokasyon: ' + item.locationName : '', item.kind].filter(Boolean).join(' · ');
      }
      function priceChips(item, mode = 'offered') {
        const pc = pcValueForCondition(item);
        const value = mode === 'desired' ? tradeValue({ ...item, quantity: 1 }) : offerValue({ ...item, quantity: 1 });
        return `<div class="price-chips"><span>PC ${pc ? money(pc) : 'yok'}</span><strong>Takas ${value ? money(value) : 'inceleme'}</strong></div>`;
      }
      function missingPhotoCount() {
        return state.offered.filter((card) => !card.frontImageBase64 || !card.backImageBase64).length;
      }
      function normalizeTradeLocationName(value) {
        const text = normalizeAddressText(value);
        if (text.includes('istanbul')) return 'istanbul';
        if (text.includes('ankara')) return 'ankara';
        return text;
      }
      function tradeRecipientForLocation(locationName) {
        const normalized = normalizeTradeLocationName(locationName);
        if (normalized === 'ankara') return "Kartolog Ankara'ya";
        if (normalized === 'istanbul') return "Kartolog İstanbul'a";
        return 'Kartolog';
      }
      function tradeLocationNotice() {
        if (!state.tradeLocationName) return '';
        return `${state.tradeLocationName} lokasyonu seçildi. Bu takasta kargo ${tradeRecipientForLocation(state.tradeLocationName)} gönderilecek; sonraki kartlar sadece aynı lokasyondan seçilebilir.`;
      }
      async function loadCities() {
        const response = await fetch(TRADE_CITIES_URL, { cache: 'force-cache' });
        const data = await response.json();
        state.cities = data.cities || [];
        setTimeout(autofillShopifyCustomerFields, 0);
        els.city.innerHTML = '<option value="">İl seç</option>' + state.cities.map((city) => `<option value="${escapeHtml(city.name)}" data-code="${escapeHtml(city.code)}">${escapeHtml(city.name)}</option>`).join('');
      }
      async function loadPokemonSets() {
        if (!els.offerSetOptions) return;
        const response = await fetch(apiPath('/trade-draft-api/pokemon-sets'));
        const data = await response.json();
        if (!response.ok || !data.ok) throw new Error(data.error || 'Set listesi alınamadı.');
        state.pokemonSets = data.items || [];
        els.offerSetOptions.innerHTML = state.pokemonSets.map((set) => `<option value="${escapeHtml(set.name)}">${escapeHtml([set.series, set.releaseDate].filter(Boolean).join(' · '))}</option>`).join('');
      }
      function selectedCity() {
        const option = els.city.selectedOptions[0];
        if (!option?.dataset.code) return null;
        return state.cities.find((city) => city.code === option.dataset.code) || null;
      }
      function renderDistricts() {
        const city = selectedCity();
        els.district.disabled = !city;
        els.district.innerHTML = !city ? '<option value="">Önce il seç</option>' : '<option value="">İlçe seç</option>' + city.districts.map((district) => `<option value="${escapeHtml(district.name)}" data-id="${escapeHtml(district.id)}">${escapeHtml(district.name)}</option>`).join('');
      }
      async function fetchStoreCards(query) {
        const url = new URL('/trade-draft-api/cards', TRADE_API_BASE || window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('limit', '24');
        if (state.tradeLocationName) url.searchParams.set('locationName', state.tradeLocationName);
        const response = await fetch(url);
        const data = await response.json();
        if (!response.ok || !data.ok) throw new Error(data.error || 'Stok kartları alınamadı.');
        return data.items || [];
      }
      async function fetchPcCards(number, setName = '') {
        const url = new URL('/trade-draft-api/pc-cards', TRADE_API_BASE || window.location.origin);
        url.searchParams.set('q', [setName, number].filter(Boolean).join(' '));
        if (setName) url.searchParams.set('setName', setName);
        if (number) url.searchParams.set('number', number);
        url.searchParams.set('game', 'pokemon');
        url.searchParams.set('limit', '12');
        const response = await fetch(url);
        const data = await response.json();
        if (!response.ok || !data.ok) throw new Error(data.error || 'Kart listesi alınamadı.');
        return data.items || [];
      }
      async function enrichStoreCard(item) {
        if (!item.pricechartingId) return item;
        try {
          const response = await fetch(apiPath('/pc-lookup/' + encodeURIComponent(item.pricechartingId)));
          const data = await response.json();
          if (!response.ok || data.ok === false) return item;
          return { ...item, rawLoosePrice: data.pricecharting?.rawLoosePrice || item.rawLoosePrice || '', loosePrice: data.pricecharting?.loosePrice || item.loosePrice || '', usdTryRate: data.pricing?.usdTryRate || item.usdTryRate || '', productName: data.pricecharting?.productName || item.productName || item.title, consoleName: data.pricecharting?.consoleName || item.consoleName || item.setName };
        } catch { return item; }
      }
      function renderSearchResults(container, items, actionName) {
        if (!items.length) { container.innerHTML = '<div class="empty"><strong>Sonuç yok.</strong><span>Daha kısa veya farklı bir arama dene.</span></div>'; return; }
        const buttonText = actionName === 'offer-add' ? 'Gönder' : 'Ekle';
        container.innerHTML = items.map((item, index) => `
          <article class="card-row search-card">
            <div class="thumb${item.imageUrl ? '' : ' empty'}">${item.imageUrl ? `<img src="${escapeHtml(item.imageUrl)}" alt="">` : '<span>Foto yok</span>'}</div>
            <div class="search-card__body">
              <div class="name">${escapeHtml(displayTitle(item))}</div>
              <div class="meta">${escapeHtml(cardInfoLine(item))}</div>
              ${priceChips(item, actionName === 'desired-add' ? 'desired' : 'offered')}
              <div class="rule-note">${escapeHtml(sellRule(item).label || '')}</div>
            </div>
            <button type="button" data-${actionName}="${index}">${buttonText}</button>
          </article>`).join('');
      }
      function renderDesired() {
        els.desiredCount.textContent = state.desired.length + ' kart';
        els.desiredPicked.innerHTML = !state.desired.length ? '<div class="empty"><strong>Henüz almak istediğin kart eklemedin.</strong><span>Kartolog stoğundan kart arayıp takas sepetine ekle.</span></div>' : state.desired.map((item, index) => `
          <article class="picked-row wanted-card">
            <div class="thumb${item.imageUrl ? '' : ' empty'}">${item.imageUrl ? `<img src="${escapeHtml(item.imageUrl)}" alt="">` : '<span>Foto yok</span>'}</div>
            <div class="picked-body">
              <div class="card-title-row"><div><div class="name">${escapeHtml(displayTitle(item))}</div><div class="meta">${escapeHtml(cardInfoLine(item))}</div></div><button class="remove" type="button" data-desired-remove="${index}">Sil</button></div>
              ${priceChips(item, 'desired')}
            </div>
          </article>`).join('');
        if (state.desired.length && tradeLocationNotice()) els.desiredPicked.insertAdjacentHTML('afterbegin', `<div class="notice" style="margin-bottom:10px;">${escapeHtml(tradeLocationNotice())}</div>`);
        renderTotals();
        saveActiveDraft();
      }
      function imagePreviewSrc(value) {
        const text = String(value || '');
        if (!text || text === '[stored]') return '';
        if (/^data:image\//i.test(text)) return text;
        return 'data:image/jpeg;base64,' + text;
      }
      function uploadPreview(value, label) {
        const src = imagePreviewSrc(value);
        if (src) return `<span class="upload-preview"><img src="${escapeHtml(src)}" alt="${escapeHtml(label)} fotoğraf önizleme"></span>`;
        if (value === '[stored]') return '<span class="upload-preview stored">Yüklü</span>';
        return '<span class="upload-preview empty">Foto yok</span>';
      }
      function uploadState(value) {
        if (!value) return '<span class="upload-state">Bekliyor</span>';
        return '<span class="upload-state ok">Yüklendi</span>';
      }
      function renderOffered() {
        els.pickedCount.textContent = String(state.offered.reduce((sum, item) => sum + Number(item.quantity || 1), 0));
        els.picked.innerHTML = !state.offered.length ? '<div class="empty"><strong>Henüz göndereceğin kart eklemedin.</strong><span>Set seç, kart numarası yaz ve adaylardan doğru baskıyı ekle.</span></div>' : state.offered.map((item, index) => `
          <article class="picked-row offered-card">
            <div class="thumb${item.imageUrl ? '' : ' empty'}">${item.imageUrl ? `<img src="${escapeHtml(item.imageUrl)}" alt="">` : '<span>Foto yok</span>'}</div>
            <div class="picked-body">
              <div class="card-title-row">
                <div><div class="name">${escapeHtml(displayTitle(item))}</div><div class="meta">${escapeHtml(cardInfoLine(item))}</div></div>
                <button class="remove" type="button" data-offer-remove="${index}">Sil</button>
              </div>
              ${priceChips(item, 'offered')}
              <div class="rule-note">${escapeHtml(sellRule(item).label || '')}</div>
              <div class="picked-controls">
                <label class="mini-field"><span>Durum</span><select data-condition="${index}" aria-label="Kondisyon">${['NM','LP','MP','HP','Hasarlı','Bilmiyorum','PSA 10','PSA 9','PSA 8'].map((condition) => `<option value="${condition}" ${item.condition === condition ? 'selected' : ''}>${condition}</option>`).join('')}</select></label>
                <label class="mini-field wide-note"><span>Not</span><input value="${escapeHtml(item.note || '')}" data-note="${index}" placeholder="Varsa not ekle"></label>
              </div>
              <p class="photo-help">Daha hızlı onay için kartın ön ve arka fotoğrafını net şekilde yükle.</p>
              <div class="upload-grid">
                <label class="upload-box">
                  <span class="upload-title">Ön fotoğraf</span>
                  ${uploadPreview(item.frontImageBase64, 'Ön')}
                  <input type="file" accept="image/*" data-front="${index}">
                  ${uploadState(item.frontImageBase64)}
                </label>
                <label class="upload-box">
                  <span class="upload-title">Arka fotoğraf</span>
                  ${uploadPreview(item.backImageBase64, 'Arka')}
                  <input type="file" accept="image/*" data-back="${index}">
                  ${uploadState(item.backImageBase64)}
                </label>
              </div>
            </div>
          </article>`).join('');
        renderTotals();
        saveActiveDraft();
      }
      function totals() {
        const desiredTotal = state.desired.reduce((sum, item) => sum + tradeValue(item), 0);
        const offerTotal = state.offered.reduce((sum, item) => sum + offerValue(item), 0);
        const volume = Math.max(desiredTotal, offerTotal);
        const shippingFee = 0;
        return {
          desiredTotal,
          offerTotal,
          volume,
          shippingFee,
          requiredTotal: desiredTotal,
          creditSurplus: Math.max(0, offerTotal - desiredTotal),
          shippingCoveredByKartolog: false,
        };
      }
      function renderTotals() {
        const total = totals();
        els.desiredTotal.textContent = money(total.desiredTotal);
        els.offerTotal.textContent = money(total.offerTotal);
        if (state.mode === 'trade-shipping') {
          els.balanceStatus.textContent = 'Başvuru no gir';
          els.submit.disabled = false;
          if (els.balanceCard) els.balanceCard.dataset.state = 'neutral';
          return;
        }
        const rejected = state.offered.filter((item) => !sellRule(item).accepted);
        const manualPricing = state.offered.some((item) => sellRule(item).manualPricing);
        const missing = total.requiredTotal - total.offerTotal;
        const surplus = total.creditSurplus;
        const photosMissing = missingPhotoCount();
        const ratio = total.requiredTotal > 0 ? Math.min(100, Math.round((total.offerTotal / total.requiredTotal) * 100)) : 0;
        if (els.balanceBarFill) els.balanceBarFill.style.width = ratio + '%';
        if (els.balanceDifference) els.balanceDifference.textContent = missing > 0 ? money(missing) + ' eksik' : surplus > 0 ? money(surplus) + ' store credit' : 'Dengede';

        let stateName = 'neutral';
        let status = 'Kart seç';
        let message = 'Almak istediğin ve göndereceğin kartları seçerek başla.';
        let disabledReason = '';
        let disabled = false;

        if (!state.desired.length) {
          disabled = true;
          disabledReason = 'Almak istediğin en az 1 kart seçmelisin.';
        } else if (!state.offered.length) {
          disabled = true;
          disabledReason = 'Göndereceğin en az 1 kart eklemelisin.';
        } else if (rejected.length) {
          stateName = 'danger';
          status = `${rejected.length} kart reddedildi`;
          message = 'Bulk kartlar kabul edilmez. Reddedilen kartları başvurudan çıkarmalısın.';
          disabled = true;
          disabledReason = message;
        } else if (photosMissing > 0) {
          stateName = 'warning';
          status = 'Fotoğraf bekliyor';
          message = `${photosMissing} kart için ön ve arka fotoğraf yüklemeleri tamamlanmalı.`;
          disabled = true;
          disabledReason = 'Fotoğraf yüklemeleri tamamlanmalı.';
        } else if (missing > 0) {
          stateName = 'warning';
          status = 'Eksik değerle inceleme';
          message = `${money(missing)} açık var. İncelemeye gönderebilirsin; işlem sonunda açık kalırsa ek ödeme fark x 1.30 olarak hesaplanır.`;
        } else if (surplus > 0) {
          stateName = 'credit';
          status = 'Store credit oluştu';
          message = `Fazla tutar mağaza kredisi olarak hesabına yüklenir. Store credit: ${money(surplus)}.`;
        } else if (manualPricing) {
          stateName = 'warning';
          status = 'Admin fiyatlaması bekliyor';
          message = 'Modern EX gibi kartlar Kartolog kontrolünde fiyatlanır; başvurunu incelemeye gönderebilirsin.';
        } else {
          stateName = 'success';
          status = 'Takas tamam';
          message = 'Başvurunu incelemeye gönderebilirsin.';
        }

        els.balanceStatus.textContent = status;
        els.submit.disabled = disabled;
        if (els.balanceCard) els.balanceCard.dataset.state = stateName;
        if (els.balanceMessage) els.balanceMessage.textContent = message;
        if (els.summaryHint) els.summaryHint.textContent = disabledReason || message;
      }
      function setMode(mode) {
        state.mode = mode;
        state.editingRequestId = mode === 'trade-shipping' ? '' : state.editingRequestId;
        els.modeButtons.forEach((button) => button.classList.toggle('active', button.dataset.mode === mode));
        const isOperations = mode === 'trade-shipping';
        els.layout.classList.toggle('single', isOperations);
        if (!isOperations) restoreSummaryPanelHome();
        els.modeHelper.textContent = isOperations
          ? 'Onaylı takas başvurusu için kargo kodu oluşturabilir veya aşağıdan işlemini takip edebilirsin.'
          : 'Takas seçilince almak istediğin kartlar ve göndereceğin kartlar birlikte takip edilir.';
        els.desiredSection.style.display = mode === 'trade' ? '' : 'none';
        els.summaryDesiredSection.style.display = mode === 'trade' ? '' : 'none';
        els.offerSearchSection.style.display = isOperations ? 'none' : '';
        els.summaryPanel.style.display = isOperations ? 'none' : '';
        els.summaryTotals.style.display = isOperations ? 'none' : '';
        els.desiredTotalBox.style.display = mode === 'trade' ? '' : 'none';
        els.offerTotalLabel.textContent = 'Gönderilen kartlar';
        els.offeredSummaryHead.style.display = isOperations ? 'none' : '';
        els.picked.style.display = isOperations ? 'none' : '';
        els.approvedShippingBox.style.display = 'none';
        els.operationsSection.style.display = isOperations ? '' : 'none';
        els.contactFields.style.display = 'none';
        [...els.contactFields.querySelectorAll('input, select, textarea')].forEach((field) => { field.required = false; });
        els.summaryTitle.textContent = isOperations ? 'İşlemlerim' : 'Başvuru özeti';
        els.submit.textContent = isOperations ? 'Kargo kodu oluştur' : 'Takas işlemini incelemeye gönder';
        els.summaryText.textContent = isOperations ? 'Shopify hesabındaki e-postaya bağlı işlemlerini görüntüleyebilirsin.' : 'Eksik değer varsa uyarıyı onaylayarak yine incelemeye gönderebilirsin.';
        els.flowNotice.style.display = isOperations ? 'none' : '';
        els.submit.style.display = '';
        els.flowNotice.textContent = 'Takas başvuru ürünü kargo/işlem hakkını açar. Takasta müşteri lehine fazla tutar kalırsa kalan fark store credit olarak hesabına yüklenir. Kargo süreci sadece Yurtiçi Kargo ile ilerler. Bizden almak istediğin kartlarda değer PC x 1.3 olarak TL hesaplanır. Göndereceğin kartlarda standart teklif İngilizce kartlar için PC x 0.9, Japonca kartlar için PC x 0.8 olarak hesaplanır. Kartın durumuna ve talebe göre değer PC değerine kadar çıkabilir. Modern EX kartlar genelde kabul edilmez; yine de inceleme için ekleyebilirsin. Bulk kartlar kabul edilmez.';
        if (isOperations) {
          if (!state.lastTrackedRequest && els.trackingResult) {
            els.trackingResult.className = 'success-box operation-detail-empty';
            els.trackingResult.innerHTML = '<strong>Detayları görmek için bir başvuru seç.</strong><p>Başvuru kartlarından birine tıklayarak işlem detaylarını görüntüleyebilirsin.</p>';
          }
          els.operationsList.innerHTML = '<div class="empty">İşlemler yükleniyor...</div>';
          loadOperations().catch((error) => {
            els.operationsList.innerHTML = `<div class="empty">${escapeHtml(error.message)}</div>`;
          });
        }
        renderDesired();
        renderOffered();
        renderTotals();
      }
      function showApprovedShippingPanel(request) {
        const canCreateShipping = (request?.mode || 'trade') === 'trade' && request?.status === 'approved_for_shipping';
        if (state.mode === 'trade-shipping' && canCreateShipping) moveSummaryPanelToOperationDetail();
        if (state.mode !== 'trade-shipping') els.layout.classList.toggle('single', !canCreateShipping);
        els.summaryPanel.style.display = canCreateShipping ? '' : 'none';
        els.summaryTotals.style.display = 'none';
        els.summaryDesiredSection.style.display = 'none';
        els.offeredSummaryHead.style.display = 'none';
        els.picked.style.display = 'none';
        els.approvedShippingBox.style.display = canCreateShipping ? '' : 'none';
        els.contactFields.style.display = canCreateShipping ? '' : 'none';
        els.flowNotice.style.display = canCreateShipping ? '' : 'none';
        els.submit.style.display = canCreateShipping ? '' : 'none';
        els.success.style.display = 'none';
        els.summaryTitle.textContent = canCreateShipping ? 'Kargo kodu oluştur' : 'Başvuru detayı';
        els.summaryText.textContent = canCreateShipping
          ? 'Bu takas onaylanmış. Adres ve kimlik bilgilerini girip kartlarını bize göndermek için kargo kodunu oluşturabilirsin.'
          : 'Bu işlem için şu anda kargo kodu oluşturma adımı yok.';
        els.flowNotice.textContent = 'Kargo kodu Yurtiçi Kargo için oluşturulur. Kod oluşturulduktan sonra gönderim için maksimum 2 gün var.';
        els.submit.textContent = 'Kargo kodu oluştur';
        els.approvedRequestId.value = request?.id || '';
        state.shippingRequestId = request?.id || '';
        [...els.contactFields.querySelectorAll('input, select, textarea')].forEach((field) => {
          field.required = canCreateShipping && field.name !== 'postalCode' && field.name !== 'note';
        });
        if (canCreateShipping) autofillShopifyCustomerFields();
      }
      function openOperation(request) {
        if (!request) return;
        setMode('trade-shipping');
        state.selectedOperationId = request.id || '';
        renderTracking(request);
        renderFilteredOperations();
      }
      function setStatus(message, type = '') { els.status.textContent = message || ''; els.status.className = 'status ' + type; }
      async function fileToBase64(file) {
        if (!file) return '';
        return new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(String(reader.result || '').replace(/^data:image\/[^;]+;base64,/i, '')); reader.onerror = () => reject(new Error('Fotoğraf okunamadı.')); reader.readAsDataURL(file); });
      }
      function contactPayload(form) {
        const phone = normalizePhone(form.get('phone'));
        els.form.elements.phone.value = phone;
        const city = selectedCity();
        const districtOption = els.district.selectedOptions[0];
        return { customer: { name: form.get('name'), email: SHOPIFY_CUSTOMER.email || form.get('email') || '', phone, tcKimlikNo: form.get('tcKimlikNo') }, address: { city: form.get('city'), cityCode: city?.code || '', district: form.get('district'), districtId: districtOption?.dataset.id || '', address1: form.get('address1'), postalCode: form.get('postalCode') } };
      }
      function customerAgreementAddress(contact) {
        const address = contact?.address || {};
        return [address.address1, address.district, address.city, address.postalCode].filter(Boolean).join(' / ') || 'Başvuru formunda belirtilen adres';
      }
      function buildShippingAgreementText(contact, requestId = '') {
        const customer = contact?.customer || {};
        const acceptedAt = new Date().toLocaleString('tr-TR');
        const partyBlock = [
          'KARTOLOG TAKAS BAŞVURU VE DEĞERLENDİRME SÖZLEŞMESİ',
          '1. Taraflar',
          'İşbu Takas Başvuru ve Değerlendirme Sözleşmesi, Kartolog üzerinden takas başvurusu oluşturan müşteri ile Kartolog arasında elektronik ortamda kurulmuştur.',
          `Kartolog:\nUnvan: ${SHIPPING_AGREEMENT_MERCHANT.title}\nAdres: ${SHIPPING_AGREEMENT_MERCHANT.address}\nE-posta: ${SHIPPING_AGREEMENT_MERCHANT.email}\nTelefon: ${SHIPPING_AGREEMENT_MERCHANT.phone}\nWeb sitesi: ${SHIPPING_AGREEMENT_MERCHANT.website}`,
          `Müşteri:\nAd Soyad: ${customer.name || SHOPIFY_CUSTOMER.name || 'Başvuru formunda belirtilen kişi'}\nTC Kimlik No: ${customer.tcKimlikNo || 'Başvuru formunda belirtilen TC kimlik no'}\nAdres: ${customerAgreementAddress(contact)}\nTelefon: ${customer.phone || 'Başvuru formunda belirtilen telefon'}\nE-posta: ${customer.email || SHOPIFY_CUSTOMER.email || 'Başvuru formunda belirtilen e-posta'}${requestId ? `\nBaşvuru No: ${requestId}` : ''}\nOnay Tarihi: ${acceptedAt}`,
          'Müşteri, işbu sözleşmeyi elektronik ortamda onaylayarak Kartolog takas başvuru sürecini, hizmet bedellerini, kargo süreçlerini, değerlendirme şartlarını, kişisel verilerin işlenmesine ilişkin bilgilendirmeyi ve cayma halinde uygulanacak kuralları kabul etmiş sayılır.',
        ];
        return [...partyBlock, ...SHIPPING_AGREEMENT_BODY].join('\n\n');
      }
      function agreementParagraphHtml(text) {
        return `<p>${escapeHtml(text).replace(/\n/g, '<br>')}</p>`;
      }
      function shippingAgreementPayload(contact, requestId = '') {
        const text = buildShippingAgreementText(contact, requestId);
        return {
          version: SHIPPING_AGREEMENT_VERSION,
          text,
          accepted: true,
          acceptedAt: new Date().toISOString(),
        };
      }
      function openShippingAgreementModal(contact, requestId = '') {
        return new Promise((resolve) => {
          const agreementText = buildShippingAgreementText(contact, requestId);
          const existing = document.querySelector('[data-trade-shipping-agreement-modal]');
          if (existing) existing.remove();
          const overlay = document.createElement('div');
          overlay.className = 'trade-agreement-modal';
          overlay.setAttribute('data-trade-shipping-agreement-modal', 'true');
          overlay.innerHTML = `
            <div class="trade-agreement-modal__panel" role="dialog" aria-modal="true" aria-labelledby="trade-agreement-title">
              <h3 id="trade-agreement-title">Takas başvuru ve değerlendirme sözleşmesi</h3>
              <div class="trade-agreement-modal__body">${agreementText.split('\n\n').map(agreementParagraphHtml).join('')}</div>
              <div class="trade-agreement-modal__actions">
                <button type="button" class="secondary" data-agreement-cancel>Vazgeç</button>
                <button type="button" data-agreement-accept>Okudum, onayladım</button>
              </div>
            </div>`;
          document.body.appendChild(overlay);
          const close = (accepted) => {
            overlay.remove();
            resolve(accepted ? shippingAgreementPayload(contact, requestId) : null);
          };
          overlay.querySelector('[data-agreement-cancel]')?.addEventListener('click', () => close(false));
          overlay.querySelector('[data-agreement-accept]')?.addEventListener('click', () => close(true));
          overlay.addEventListener('click', (event) => {
            if (event.target === overlay) close(false);
          });
        });
      }
      function requestPayload() {
        const total = totals();
        const payload = { mode: 'trade', customer: { name: SHOPIFY_CUSTOMER.name || '', email: SHOPIFY_CUSTOMER.email || '', phone: normalizePhone(SHOPIFY_CUSTOMER.phone) }, desiredCards: state.desired.map((item) => ({ ...item, lineId: item.lineId || item._lineId || createLineId('desired'), quantity: 1, estimatedValue: tradeValue({ ...item, quantity: 1 }) })), offeredCards: state.offered.map((item) => ({ ...item, lineId: item.lineId || item._lineId || createLineId('offered'), quantity: 1, estimatedValue: offerValue({ ...item, quantity: 1 }), manualPricing: Boolean(sellRule(item).manualPricing) })), totals: { desiredTotal: total.desiredTotal, offerTotal: total.offerTotal, shippingFee: total.shippingFee, requiredTotal: total.requiredTotal, volume: total.volume, creditSurplus: total.creditSurplus, hasManualPricing: state.offered.some((item) => sellRule(item).manualPricing), shippingCoveredByKartolog: total.shippingCoveredByKartolog, multiplier: VALUE_MULTIPLIER, currency: 'TRY' }, note: new FormData(els.form).get('note') };
        return payload;
      }
      function statusText(status) {
        return ({
          awaiting_customer_selection: 'Baslatilabilir',
          pending_trade_review: 'İncelemede',
          pending_store_credit_review: 'İncelemede',
          review_updated: 'Güncellendi, kontrol et',
          extra_payment_pending: 'Ek ödeme bekliyor',
          extra_payment_paid: 'Ek ödeme alındı',
          revised_offer_accepted: 'Revize teklif onaylandı',
          withdrawal_requested: 'Cayma talebi',
          rejected: 'Reddedildi',
          approved_for_shipping: 'Onaylandı',
          approved_for_outbound_shipping: 'Kartolog kargosu hazırlanıyor',
          draft_shipping_code_created: 'Kargolandı',
          geliver_label_created: 'Kargolandı',
          geliver_shipment_created: 'Kargolandı',
          completed: 'Tamamlandı',
        })[status] || status || '-';
      }
      function modeText(mode) { return mode === 'intake' ? 'Basvuru' : 'Takas'; }
      function modeIcon(mode) {
        const isIntake = mode === 'intake';
        const icon = isIntake
            ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h10v10H7z"/><path d="M9 7a3 3 0 0 1 6 0"/><path d="M9 12h6"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h11l-3-3"/><path d="M18 7l-3 3"/><path d="M17 17H6l3 3"/><path d="M6 17l3-3"/></svg>';
        return `<span class="mode-icon ${isIntake ? 'intake' : 'trade'}" title="${escapeHtml(modeText(mode))}">${icon}</span>`;
      }
      function renderTracking(request) {
        state.lastTrackedRequest = request;
        showApprovedShippingPanel(request);
        const desired = request.desiredCards || [];
        const offered = request.offeredCards || [];
        const shipping = request.shipping || {};
        const outbound = request.outboundShipping || {};
        const cards = [...desired.map((card) => 'Alınacak: ' + card.title), ...offered.map((card) => 'Gönderilecek: ' + card.title)].slice(0, 10);
        const rejectionReason = request.rejectionReason || request.review?.rejectionReason || '';
        const reviewUpdatedBlock = request.status === 'review_updated'
          ? `<div class="notice" style="margin-top:12px;"><b>Revize değerler hazır</b><p style="margin-top:6px;">Kartlar fiziksel olarak incelendi ve değerler güncellendi. Devam etmek istersen revizeyi onaylayabilir, istemezsen cayma talebi gönderebilirsin.</p><div style="display:flex; gap:10px; flex-wrap:wrap; margin-top:10px;"><button type="button" data-revised-offer-decision="accept">Revizeyi onaylıyorum</button><button class="secondary" type="button" data-revised-offer-decision="withdraw">Cayma talep ediyorum</button></div></div>`
          : '';
        const revisedDecisionBlock = request.status === 'revised_offer_accepted'
          ? `<div class="notice" style="margin-top:12px;"><b>Revize teklif onaylandı</b><p style="margin-top:6px;">Kartolog artık takasın sonraki adımına geçebilir.</p></div>`
          : request.status === 'withdrawal_requested'
            ? `<div class="notice" style="margin-top:12px;"><b>Cayma talebi alındı</b><p style="margin-top:6px;">Kartolog cayma talebini görüp süreç için seninle iletişime geçecek.</p></div>`
            : '';
        const outboundBlock = outbound.shippingCode
          ? `<div class="notice" style="margin-top:12px;"><b>Sana gelecek kargo</b><p style="margin-top:6px;">Kod: <b>${escapeHtml(outbound.shippingCode)}</b>${outbound.provider ? '<br>Firma: ' + escapeHtml(outbound.provider) : ''}${outbound.trackingUrl ? '<br><a href="' + escapeHtml(outbound.trackingUrl) + '" target="_blank" rel="noreferrer">Sana gelecek kargo takip linki</a>' : ''}${outbound.note ? '<br>' + escapeHtml(outbound.note) : ''}</p></div>`
          : '';
        const intakeButtons = request.status === 'awaiting_customer_selection'
          ? `<div class="notice" style="margin-top:12px;"><b>Başvuru hakkı hazır</b><p style="margin-top:6px;">Takas başlat, kartları ekle ve incelemeye gönder.</p><div style="display:flex; gap:10px; flex-wrap:wrap; margin-top:10px;"><button type="button" data-start-intake="trade">Takas başlat</button></div></div>`
          : '';
        const editButton = request.status === 'rejected'
          ? `<button type="button" data-edit-request="${escapeHtml(request.id)}" style="margin-top:12px;">Düzenle ve tekrar gönder</button>`
          : '';
        els.trackingResult.style.display = 'block';
        const creditSurplusBlock = Number(request.totals?.creditSurplus || 0) > 0
          ? `<p>Fazla kalan tutar: <b>${money(request.totals.creditSurplus)}</b> store credit olarak hesabına yüklenir.</p>`
          : '';
        els.trackingResult.innerHTML = `Başvuru no: ${escapeHtml(request.id)}<strong>${escapeHtml(statusText(request.status))}</strong><p style="margin-top:8px;">İşlem tipi: Takas</p><p>İstenen: ${money(request.totals?.desiredTotal || 0)} · Gönderilen: ${money(request.totals?.offerTotal || 0)}</p>${creditSurplusBlock}${reviewUpdatedBlock}${revisedDecisionBlock}${rejectionReason ? `<div class="notice" style="margin-top:12px;"><b>Reddedilme sebebi</b><p style="margin-top:6px;">${escapeHtml(rejectionReason)}</p></div>` : ''}${request.shippingCode ? `<p>Bize gönderilecek kargo kodu: <b>${escapeHtml(request.shippingCode)}</b></p>` : ''}${request.shippingDeadlineAt ? `<p>Son gönderim: ${escapeHtml(new Date(request.shippingDeadlineAt).toLocaleString('tr-TR'))}</p>` : ''}${shipping.trackingUrl ? `<p><a href="${escapeHtml(shipping.trackingUrl)}" target="_blank" rel="noreferrer">Bize gelen kargo takip linki</a></p>` : ''}${outboundBlock}${cards.length ? `<p style="margin-top:8px;">${cards.map(escapeHtml).join('<br>')}</p>` : ''}${editButton}`;
        if (intakeButtons) els.trackingResult.insertAdjacentHTML('afterbegin', intakeButtons);
      }
      function renderTracking(request) {
        state.lastTrackedRequest = request;
        showApprovedShippingPanel(request);
        const desired = request.desiredCards || [];
        const offered = request.offeredCards || [];
        const shipping = request.shipping || {};
        const outbound = request.outboundShipping || {};
        const extraPayment = request.extraPayment || null;
        const rejectionReason = request.rejectionReason || request.review?.rejectionReason || '';
        const group = operationStatusGroup(request.status);
        const nextStep = operationNextStep(request);
        const detailActions = operationDetailActions(request);
        const hasBalanceDue = Number(request.totals?.balanceDue || 0) > 0;
        const reviewUpdatedBlock = request.status === 'review_updated'
          ? `<div class="operation-alert operation-alert--warning"><b>Revize değerler hazır</b><p>Kartlar fiziksel olarak incelendi ve değerler güncellendi. ${hasBalanceDue ? 'Eksik tutar oluştuysa Kartolog ödeme linki oluşturacak; istemezsen cayma talebi gönderebilirsin.' : 'Devam etmek istersen revizeyi onaylayabilir, istemezsen cayma talebi gönderebilirsin.'}</p><div class="detail-actions">${hasBalanceDue ? '' : '<button type="button" data-revised-offer-decision="accept">Revizeyi onaylıyorum</button>'}<button class="secondary" type="button" data-revised-offer-decision="withdraw">Cayma talep ediyorum</button></div></div>`
          : '';
        const revisedDecisionBlock = request.status === 'revised_offer_accepted'
          ? `<div class="operation-alert operation-alert--ok"><b>Revize teklif onaylandı</b><p>Kartolog artık takasın sonraki adımına geçebilir.</p></div>`
          : request.status === 'withdrawal_requested'
            ? `<div class="operation-alert operation-alert--warning"><b>Cayma talebi alındı</b><p>Kartolog cayma talebini görüp süreç için seninle iletişime geçecek.</p></div>`
            : '';
        const outboundBlock = shipmentDetailHtml('Sana gelecek kargo', outbound);
        const creditSurplusBlock = Number(request.totals?.creditSurplus || 0) > 0
          ? `<div class="operation-alert operation-alert--ok"><b>Store credit oluştu</b><p>Fazla kalan <b>${money(request.totals.creditSurplus)}</b> hesabına store credit olarak yüklenir.</p></div>`
          : '';
        const extraPaymentBlock = extraPayment?.checkoutUrl || Number(request.totals?.balanceDue || 0) > 0
          ? `<div class="operation-alert ${extraPayment?.status === 'paid' ? 'operation-alert--ok' : 'operation-alert--warning'}"><b>${extraPayment?.status === 'paid' ? 'Ek ödeme alındı' : 'Ek ödeme bekliyor'}</b><p>Fiziksel inceleme sonrası eksik kalan ödeme tutarı: <b>${money(extraPayment?.amount || request.totals?.balanceDue || 0)}</b>. Bu tutar açık kalan fark x 1.30 olarak hesaplanır.</p>${extraPayment?.status === 'paid' ? '<p>Ödeme göründü. Kartolog ekibi sana gelecek kargoyu hazırlayacak.</p>' : extraPayment?.checkoutUrl ? `<div class="detail-actions"><a class="primary-link" href="${escapeHtml(extraPayment.checkoutUrl)}" target="_blank" rel="noreferrer">Ek ödemeyi Shopify'da yap</a></div>` : '<p>Ödeme linki Kartolog tarafından oluşturulacak.</p>'}</div>`
          : '';
        const shippingBlock = shipmentDetailHtml('Bize gelecek kargo', { ...shipping, shippingCode: request.shippingCode || shipping.shippingCode || '' }) +
          (request.shippingDeadlineAt ? `<section class="detail-card"><h3>Gönderim süresi</h3><p>Son gönderim: ${escapeHtml(new Date(request.shippingDeadlineAt).toLocaleString('tr-TR'))}</p></section>` : '');
        els.trackingResult.style.display = 'block';
        els.trackingResult.className = 'success-box operation-detail-content';
        els.trackingResult.innerHTML = `
          <header class="operation-detail-hero">
            <div>
              <span class="status-badge status-${escapeHtml(group)}">${escapeHtml(request.displayStatus || statusText(request.status))}</span>
              <h3>${escapeHtml(request.id)}</h3>
              <p>${request.createdAt ? escapeHtml(new Date(request.createdAt).toLocaleString('tr-TR')) : 'Tarih bilgisi yok'}</p>
            </div>
            <span class="operation-detail-type">Takas</span>
          </header>
          <section class="detail-card">
            <h3>Sıradaki adım</h3>
            <p>${escapeHtml(nextStep)}</p>
            ${detailActions ? `<div class="detail-actions">${detailActions}</div>` : ''}
          </section>
          ${operationFinanceGrid(request)}
          ${operationTimeline(request.status)}
          ${creditSurplusBlock}
          ${extraPaymentBlock}
          ${reviewUpdatedBlock}
          ${revisedDecisionBlock}
          ${rejectionReason ? `<div class="operation-alert operation-alert--danger"><b>Reddedilme sebebi</b><p>${escapeHtml(rejectionReason)}</p></div>` : ''}
          ${shippingBlock}
          ${outboundBlock}
          ${operationCardsSection('Almak istediğin kartlar', desired, false)}
          ${operationCardsSection('Gönderdiğin kartlar ve fotoğraflar', offered, true)}
        `;
      }
      function startIntakeRequest(request) {
        if (!request || request.status !== 'awaiting_customer_selection') return;
        hydrateTradeDraft(request);
        els.success.style.display = 'none';
        setStatus(`${request.id} başvuru hakkı Takas olarak dolduruluyor.`, 'ok');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      function editRejectedRequest(request) {
        if (!request || (request.status !== 'rejected' && request.status !== 'review_updated')) return;
        state.editingRequestId = request.id;
        const desiredCards = withDistributedEstimatedValue(request.desiredCards || [], request.totals?.desiredTotal || 0);
        state.desired = expandQuantityCards(desiredCards, 'desired').map((item) => restoreRawLoosePrice({ ...item, quantity: 1 }, VALUE_MULTIPLIER));
        state.offered = expandQuantityCards(request.offeredCards || [], 'offered').map((item) => ({
          ...restoreRawLoosePrice(item),
          quantity: 1,
          condition: item.condition || 'NM',
          note: item.note || '',
          frontImageBase64: item.frontImageBase64 || '[stored]',
          backImageBase64: item.backImageBase64 || '[stored]',
        }));
        setMode('trade');
        els.success.style.display = 'none';
        setStatus(`${request.id} reddedilen başvuru düzenleniyor. Değişiklikleri yapıp tekrar incelemeye gönderebilirsin.`, 'ok');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      function renderOperations(items) {
        state.operations = Array.isArray(items) ? items : [];
        renderOperationStats(state.operations);
        renderFilteredOperations();
      }
      function operationStatusGroup(status) {
        const value = String(status || '');
        if (value === 'awaiting_customer_selection') return 'startable';
        if (['pending_trade_review', 'pending_store_credit_review', 'review_updated', 'extra_payment_pending'].includes(value)) return 'review';
        if (['approved_for_shipping', 'approved_for_outbound_shipping', 'revised_offer_accepted', 'extra_payment_paid', 'draft_shipping_code_created', 'geliver_label_created', 'geliver_shipment_created'].includes(value)) return 'shipping';
        if (value === 'completed') return 'completed';
        if (['rejected', 'withdrawal_requested', 'cancelled'].includes(value)) return 'cancelled';
        return 'review';
      }
      function operationProgress(status) {
        return ({
          awaiting_customer_selection: 18,
          pending_trade_review: 38,
          pending_store_credit_review: 38,
          review_updated: 52,
          extra_payment_pending: 58,
          extra_payment_paid: 66,
          revised_offer_accepted: 62,
          approved_for_outbound_shipping: 72,
          approved_for_shipping: 70,
          draft_shipping_code_created: 82,
          geliver_label_created: 82,
          geliver_shipment_created: 82,
          completed: 100,
          rejected: 100,
          withdrawal_requested: 100,
        })[status] || 28;
      }
      function operationActionLabel(status) {
        if (status === 'awaiting_customer_selection') return 'Devam Et';
        if (status === 'approved_for_shipping') return 'Kargo Kodu Oluştur';
        if (status === 'extra_payment_pending') return 'Ödeme Linki';
        if (status === 'extra_payment_paid') return 'Kartolog Kargosunu Bekle';
        if (status === 'review_updated') return 'Revizeyi Gör';
        if (status === 'approved_for_outbound_shipping' || status === 'revised_offer_accepted') return 'Kartolog Kargosunu Bekle';
        if (['draft_shipping_code_created', 'geliver_label_created', 'geliver_shipment_created'].includes(status)) return 'Takip Et';
        return 'Detayı Gör';
      }
      function operationNextStep(request) {
        const status = String(request?.status || '');
        if (status === 'awaiting_customer_selection') return 'Takas başlatıp almak istediğin ve göndereceğin kartları ekleyebilirsin.';
        if (status === 'approved_for_shipping') return 'Kargo kodu oluşturabilirsin. Kod seçili başvuru için üretilecek.';
        if (status === 'approved_for_outbound_shipping') return 'İşlem onaylandı. Kartolog ekibi sana gönderilecek kartlar için kargo hazırlıyor.';
        if (status === 'extra_payment_pending') return 'Fiziksel inceleme sonrası eksik tutar oluştu. Ek ödeme linki üzerinden ödeme yapınca Kartolog kargo aşamasına geçecek.';
        if (status === 'extra_payment_paid') return 'Ek ödeme alındı. Kartolog ekibi sana gönderilecek kartlar için kargo hazırlayacak.';
        if (status === 'revised_offer_accepted') return 'Revize teklif onaylandı. Kartolog ekibi sana gönderilecek kartlar için kargo hazırlayacak.';
        if (['draft_shipping_code_created', 'geliver_label_created', 'geliver_shipment_created'].includes(status)) return 'Kargo sürecini takip edebilirsin.';
        if (status === 'pending_trade_review' || status === 'pending_store_credit_review') return 'Kartların Kartolog ekibi tarafından inceleniyor.';
        if (status === 'review_updated') return 'Revize değerlerle devam etmek için onay verebilir veya cayma talebi gönderebilirsin.';
        if (status === 'rejected') return 'Reddedilme sebebini kontrol edip başvuruyu düzenleyerek tekrar gönderebilirsin.';
        if (status === 'completed') return 'Bu takas işlemi tamamlandı.';
        if (status === 'withdrawal_requested') return 'Cayma talebin Kartolog ekibine iletildi.';
        return 'Başvuru detaylarını aşağıdan takip edebilirsin.';
      }
      function operationDetailActions(request) {
        const status = String(request?.status || '');
        if (status === 'awaiting_customer_selection') return '<button type="button" data-start-intake="trade">Takas başlat</button>';
        if (status === 'rejected') return `<button type="button" data-edit-request="${escapeHtml(request.id)}">Düzenle ve tekrar gönder</button>`;
        if (status === 'review_updated') return Number(request?.totals?.balanceDue || 0) > 0
          ? '<button class="secondary" type="button" data-revised-offer-decision="withdraw">Cayma talep ediyorum</button>'
          : '<button type="button" data-revised-offer-decision="accept">Revizeyi onaylıyorum</button><button class="secondary" type="button" data-revised-offer-decision="withdraw">Cayma talep ediyorum</button>';
        if (status === 'extra_payment_pending' && request?.extraPayment?.checkoutUrl) return `<a class="primary-link" href="${escapeHtml(request.extraPayment.checkoutUrl)}" target="_blank" rel="noreferrer">Ek ödemeyi yap</a><button class="secondary" type="button" data-revised-offer-decision="withdraw">Cayma talep ediyorum</button>`;
        if (status === 'approved_for_shipping') return '<a class="primary-link" href="#operation-shipping-form-slot">Kargo formuna git</a>';
        const trackingUrl = request?.shipping?.trackingUrl || request?.outboundShipping?.trackingUrl || '';
        if (trackingUrl) return `<a class="primary-link" href="${escapeHtml(trackingUrl)}" target="_blank" rel="noreferrer">Takip et</a>`;
        return '';
      }
      function shipmentDetailHtml(title, shipment) {
        if (!shipment?.shippingCode && !shipment?.trackingNumber && !shipment?.trackingUrl && !shipment?.labelUrl) return '';
        const lines = [
          shipment.provider ? `<p>Firma: ${escapeHtml(shipment.provider)}</p>` : '',
          shipment.shippingCode ? `<p>Kargo kodu: <b>${escapeHtml(shipment.shippingCode)}</b></p>` : '',
          shipment.trackingNumber ? `<p>Takip no: <b>${escapeHtml(shipment.trackingNumber)}</b></p>` : '',
          shipment.trackingUrl ? `<p><a href="${escapeHtml(shipment.trackingUrl)}" target="_blank" rel="noreferrer">Takip linkini aç</a></p>` : '',
          shipment.labelUrl ? `<p><a href="${escapeHtml(shipment.labelUrl)}" target="_blank" rel="noreferrer">Kargo etiketini aç</a></p>` : '',
          shipment.note ? `<p>${escapeHtml(shipment.note)}</p>` : '',
        ].filter(Boolean).join('');
        return `<section class="detail-card"><h3>${escapeHtml(title)}</h3>${lines}</section>`;
      }
      function operationFinanceGrid(request) {
        const totals = request?.totals || {};
        const cells = [
          ['İstediğin kartlar', totals.desiredTotal],
          ['Gönderdiğin kartlar', totals.offerTotal],
          ['Mağaza kredisi hesabına yatacak tutar', totals.storeCreditAmount || totals.creditSurplus],
          ['Ek ödeme tutarı (fark x 1.30)', totals.balanceDue],
          ['İşlem hacmi', totals.volume],
        ].filter((entry) => Number(entry[1] || 0) > 0);
        if (!cells.length) return '';
        return `<section class="detail-card"><h3>Finansal özet</h3><div class="detail-finance-grid">${cells.map(([label, value]) => `<span><small>${escapeHtml(label)}</small><b>${money(value)}</b></span>`).join('')}</div></section>`;
      }
      function operationTimeline(status) {
        const steps = [
          ['Başvuru', ['awaiting_customer_selection']],
          ['Kargo', ['approved_for_shipping', 'draft_shipping_code_created', 'geliver_label_created', 'geliver_shipment_created']],
          ['İnceleme', ['pending_trade_review', 'pending_store_credit_review', 'review_updated', 'extra_payment_pending', 'extra_payment_paid', 'revised_offer_accepted', 'withdrawal_requested', 'rejected']],
          ['Onay', ['approved_for_shipping', 'approved_for_outbound_shipping', 'extra_payment_paid', 'revised_offer_accepted']],
          ['Tamamlandı', ['completed']],
        ];
        const progress = operationProgress(status);
        return `<section class="detail-card"><h3>Süreç</h3><div class="detail-timeline" style="--progress:${progress}%">${steps.map(([label, statuses]) => `<span class="${statuses.includes(status) || progress >= 100 ? 'active' : ''}"><i></i>${escapeHtml(label)}</span>`).join('')}</div></section>`;
      }
      function operationCardsSection(title, cards, withPhotos) {
        if (!cards?.length) return '';
        return `<section class="detail-card detail-card--cards"><h3>${escapeHtml(title)}</h3><div class="detail-card-list">${cards.map((card, index) => operationCardHtml(card, withPhotos, index)).join('')}</div></section>`;
      }
      function reviewValueHtml(card) {
        const previous = Number(card.reviewPreviousValue || 0);
        const current = Number(card.reviewedValue || card.estimatedValue || 0);
        const hasRevision = Boolean(card.reviewValueChangedAt) || Math.abs(previous - current) >= 0.01;
        if (!hasRevision) return '';
        return `<div class="detail-value-change" aria-label="Revize teklif değer değişimi"><span><small>Önceki değer</small>${money(previous)}</span><b><small>Revize değer</small>${money(current)}</b></div>`;
      }
      function removedFromTradeHtml(card) {
        if (!card.removedFromTrade) return '';
        return `<div class="operation-alert operation-alert--danger" style="margin-top:10px;"><b>Kart takastan çıkarıldı</b><p>${escapeHtml(card.removedFromTradeReason || 'Bu kart Kartolog incelemesi sonrası takas kapsamından çıkarıldı.')}</p></div>`;
      }
      function operationCardHtml(card, withPhotos, index = 0) {
        const front = card.frontImageBase64 || '';
        const back = card.backImageBase64 || '';
        const wantsPhotoRefresh = withPhotos && card.photoRefreshRequested;
        const photoRefreshBlock = wantsPhotoRefresh
          ? `<div class="photo-refresh-panel">
              <b>Fotoğraf tekrar isteniyor</b>
              <p>${escapeHtml(card.photoRefreshReason || 'Kartın ön ve arka fotoğrafını tekrar yüklemen gerekiyor.')}</p>
              <div class="detail-photo-pair">
                <label class="upload-box"><span class="upload-title">Yeni ön fotoğraf</span><input data-review-photo-front="${index}" type="file" accept="image/*"></label>
                <label class="upload-box"><span class="upload-title">Yeni arka fotoğraf</span><input data-review-photo-back="${index}" type="file" accept="image/*"></label>
              </div>
            </div>`
          : '';
        const photoBlock = withPhotos
          ? `<div class="detail-photo-pair">
              <div class="upload-box"><span class="upload-title">Ön fotoğraf</span>${uploadPreview(front, 'Ön')}${uploadState(front)}</div>
              <div class="upload-box"><span class="upload-title">Arka fotoğraf</span>${uploadPreview(back, 'Arka')}${uploadState(back)}</div>
            </div>`
          : '';
        return `<article class="detail-line-card">
          <div class="thumb">${card.imageUrl ? `<img src="${escapeHtml(card.imageUrl)}" alt="">` : ''}</div>
          <div class="detail-line-card__body">
            <div class="name">${escapeHtml(displayTitle(card))}</div>
            <div class="meta">${escapeHtml(cardInfoLine(card))}</div>
            ${reviewValueHtml(card)}
            ${removedFromTradeHtml(card)}
            <div class="detail-card-badges">
              ${card.condition ? `<span>${escapeHtml(card.condition)}</span>` : ''}
              <span>${escapeHtml(String(card.quantity || 1))} adet</span>
              ${card.removedFromTrade ? '<span class="missing">Takastan çıkarıldı</span>' : ''}
              ${withPhotos ? `<span class="${front && back ? 'ok' : 'missing'}">${front && back ? 'Fotoğraf yüklendi' : 'Fotoğraf eksik'}</span>` : ''}
              ${wantsPhotoRefresh ? '<span class="missing">Yeniden fotoğraf bekleniyor</span>' : ''}
            </div>
            ${photoBlock}
            ${photoRefreshBlock}
          </div>
        </article>`;
      }
      function operationNote(item) {
        const group = operationStatusGroup(item.status);
        if (group === 'startable') return 'Takas başvurusu hazır. Kartlarını ekleyip incelemeye gönderebilirsin.';
        if (group === 'review') return 'Başvurun Kartolog incelemesinde. Güncelleme olursa bu ekranda görünür.';
        if (group === 'shipping') return 'Kargo adımı aktif. Kod veya takip bilgilerini detayda görüntüleyebilirsin.';
        if (group === 'completed') return 'İşlem tamamlandı. Detayları istediğin zaman görüntüleyebilirsin.';
        return 'Bu işlem için detayları görüntüleyebilir veya uygunsa düzenleyebilirsin.';
      }
      function renderOperationStats(items) {
        const stats = items.reduce((acc, item) => {
          const group = operationStatusGroup(item.status);
          acc.total += 1;
          if (group === 'review') acc.review += 1;
          if (group === 'startable' || group === 'shipping') acc.shipping += 1;
          if (group === 'completed') acc.completed += 1;
          return acc;
        }, { total: 0, review: 0, shipping: 0, completed: 0 });
        if (els.opsStatTotal) els.opsStatTotal.textContent = String(stats.total);
        if (els.opsStatReview) els.opsStatReview.textContent = String(stats.review);
        if (els.opsStatShipping) els.opsStatShipping.textContent = String(stats.shipping);
        if (els.opsStatCompleted) els.opsStatCompleted.textContent = String(stats.completed);
      }
      function filteredOperations() {
        const query = String(els.operationsSearch?.value || '').trim().toLowerCase();
        const filter = String(els.operationsStatusFilter?.value || 'all');
        const sort = String(els.operationsSort?.value || 'newest');
        const list = state.operations.filter((item) => {
          const matchesQuery = !query || [item.id, item.displayStatus, statusText(item.status)].filter(Boolean).join(' ').toLowerCase().includes(query);
          const matchesStatus = filter === 'all' || operationStatusGroup(item.status) === filter;
          return matchesQuery && matchesStatus;
        });
        list.sort((a, b) => {
          if (sort === 'oldest') return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
          if (sort === 'volume-desc') return Number(b.volume || 0) - Number(a.volume || 0);
          if (sort === 'volume-asc') return Number(a.volume || 0) - Number(b.volume || 0);
          return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
        });
        return list;
      }
      function renderFilteredOperations() {
        const items = filteredOperations();
        if (!state.operations.length) {
          els.operationsList.innerHTML = `<div class="orders-empty"><strong>Henüz bir takas başvurun yok</strong><p>İlk takas başvurunu oluşturarak Kartolog'a göndermek istediğin kartları ekleyebilirsin.</p><a class="primary-link" href="${escapeHtml(INTAKE_PRODUCT_URL)}">Yeni Takas Başlat</a></div>`;
          return;
        }
        if (!items.length) {
          els.operationsList.innerHTML = '<div class="empty"><strong>Filtreye uygun işlem bulunamadı.</strong><span>Arama metnini veya durum filtresini değiştirerek tekrar dene.</span></div>';
          return;
        }
        els.operationsList.innerHTML = items.map((item) => {
          const group = operationStatusGroup(item.status);
          const progress = operationProgress(item.status);
          const dateText = item.createdAt ? new Date(item.createdAt).toLocaleString('tr-TR') : '-';
          return `
            <article class="operation-card ${state.selectedOperationId === item.id ? 'is-selected' : ''}" data-operation-id="${escapeHtml(item.id)}">
              <div class="operation-card__icon">${modeIcon(item.mode)}</div>
              <div class="operation-card__content">
                <div class="operation-card__top">
                  <div>
                    <div class="operation-id">${escapeHtml(item.id)}</div>
                    <div class="operation-date">${escapeHtml(dateText)}</div>
                  </div>
                  <span class="status-badge status-${escapeHtml(group)}">${escapeHtml(item.displayStatus || statusText(item.status))}</span>
                </div>
                <div class="operation-metrics">
                  <span><b>Hacim</b>${escapeHtml(money(item.volume || 0))}</span>
                  <span><b>Gönderilen</b>${escapeHtml(String(item.offeredCount || 0))} kart</span>
                  <span><b>Durum</b>${escapeHtml(statusText(item.status))}</span>
                </div>
                <p class="operation-note">${escapeHtml(operationNote(item))}</p>
                <div class="operation-progress" aria-hidden="true"><span style="width:${progress}%"></span></div>
                <div class="operation-steps"><span>Başvuru</span><span>İnceleme</span><span>Kargo</span><span>Tamamlandı</span></div>
              </div>
              <div class="operation-card__actions">
                <button type="button" data-operation-id="${escapeHtml(item.id)}">${escapeHtml(operationActionLabel(item.status))}</button>
              </div>
            </article>`;
        }).join('');
      }
      function hydrateTradeDraft(request) {
        if (!request) return;
        const saved = loadSavedDraft(request.id);
        const savedExists = hasSavedDraft(request.id) && savedDraftIsFresh(saved, request);
        const requestDesired = expandQuantityCards(withDistributedEstimatedValue(request.desiredCards || [], request.totals?.desiredTotal || 0), 'desired')
          .map((item) => restoreRawLoosePrice({ ...item, quantity: 1 }, VALUE_MULTIPLIER));
        const savedDesired = expandQuantityCards(saved?.desired || [], 'desired-saved').map((item) => restoreRawLoosePrice({ ...item, quantity: 1 }, VALUE_MULTIPLIER));
        const requestOffered = expandQuantityCards(request.offeredCards || [], 'offered').map((item) => ({
          ...restoreRawLoosePrice(item),
          quantity: 1,
          condition: item.condition || 'NM',
          note: item.note || '',
          frontImageBase64: item.frontImageBase64 || '',
          backImageBase64: item.backImageBase64 || '',
        }));
        const savedOffered = expandQuantityCards(saved?.offered || [], 'offered-saved').map((item) => ({
          ...restoreRawLoosePrice(item),
          quantity: 1,
          condition: item.condition || 'NM',
          note: item.note || '',
          frontImageBase64: item.frontImageBase64 || '',
          backImageBase64: item.backImageBase64 || '',
        }));
        state.editingRequestId = request.id;
        state.desiredResults = [];
        state.offeredResults = [];
        state.desired = savedExists ? savedDesired : requestDesired;
        state.offered = savedExists ? savedOffered : requestOffered;
        state.tradeLocationName = request.tradeLocationName || saved?.tradeLocationName || state.desired[0]?.locationName || '';
        setMode('trade');
        renderDesired();
        renderOffered();
        saveActiveDraft();
      }
      async function loadOperations(contact = '') {
        if (TRADE_PROXY_BASE) {
          await syncIntakePurchases();
        }
        const url = new URL(customerApiPath('/trade-draft-api/requests'), window.location.origin);
        const tokens = allAccessTokens();
        const email = TRADE_PROXY_BASE ? '' : String(SHOPIFY_CUSTOMER.email || '').trim();
        if (email) url.searchParams.set('email', email);
        if (!tokens.length && !email) {
          if (TRADE_PROXY_BASE) {
            // Shopify App Proxy will attach the signed customer id when the visitor is logged in.
          } else {
            els.operationsList.innerHTML = '<div class="empty">İşlemlerini görmek için Shopify hesabınla giriş yapmalısın.</div>';
            return;
          }
        }
        if (!tokens.length && !email && !TRADE_PROXY_BASE) {
          return;
        }
        const headers = {};
        if (tokens.length) headers['x-kartolog-trade-tokens'] = tokens.join(',');
        const response = await fetch(url, { headers });
        const data = await readJsonResponse(response, 'İşlemler alınamadı. Lütfen sayfayı yenileyip tekrar dene.');
        if (!response.ok || !data.ok) throw new Error(data.error || 'İşlemler alınamadı.');
        renderOperations(data.requests || []);
      }
      async function syncIntakePurchases() {
        const response = await fetch(customerApiPath('/trade-draft-api/purchases/sync'), { method: 'POST' });
        const data = await readJsonResponse(response, 'Başvuru satın alımları okunamadı.').catch(() => ({}));
        if (!response.ok || !data.ok) throw new Error(data.error || 'Basvuru satin alimlari okunamadi.');
        return data;
      }
      async function fetchOperationDetailForDraft(id) {
        const url = new URL(customerApiPath('/trade-draft-api/requests/' + encodeURIComponent(id)), window.location.origin);
        const accessToken = accessTokenForRequest(id);
        const email = TRADE_PROXY_BASE ? '' : String(SHOPIFY_CUSTOMER.email || '').trim();
        if (email) url.searchParams.set('email', email);
        const headers = {};
        if (accessToken) headers['x-kartolog-trade-token'] = accessToken;
        const response = await fetch(url, { headers });
        let data;
        try {
          data = await readJsonResponse(response, 'İşlem detayı alınamadı. Lütfen sayfayı yenileyip tekrar dene.');
        } catch (error) {
          if (!TRADE_PROXY_BASE) throw error;
          const proxyFallbackUrl = new URL(customerApiPath('/trade-draft-api/requests'), window.location.origin);
          proxyFallbackUrl.searchParams.set('id', id);
          try {
            const proxyFallbackResponse = await fetch(proxyFallbackUrl, { headers });
            data = await readJsonResponse(proxyFallbackResponse, 'İşlem detayı alınamadı. Lütfen sayfayı yenileyip tekrar dene.');
            if (!proxyFallbackResponse.ok || !data.ok) throw new Error(data.error || 'İşlem detayı alınamadı.');
            return data.request;
          } catch (proxyError) {
            if (!TRADE_API_BASE) throw proxyError;
          }
          const fallbackUrl = new URL(apiPath('/trade-draft-api/requests/' + encodeURIComponent(id)), window.location.origin);
          if (SHOPIFY_CUSTOMER.email) fallbackUrl.searchParams.set('email', SHOPIFY_CUSTOMER.email);
          const fallbackResponse = await fetch(fallbackUrl, { headers });
          data = await readJsonResponse(fallbackResponse, 'İşlem detayı alınamadı. Lütfen sayfayı yenileyip tekrar dene.');
          if (!fallbackResponse.ok || !data.ok) throw new Error(data.error || 'İşlem detayı alınamadı.');
          return data.request;
        }
        if (!response.ok || !data.ok) throw new Error(data.error || 'İşlem detayı alınamadı.');
        return data.request;
      }
      async function loadActiveDraftOnEntry() {
        if (!TRADE_PROXY_BASE || state.editingRequestId) return;
        await syncIntakePurchases();
        const response = await fetch(customerApiPath('/trade-draft-api/requests'));
        const data = await readJsonResponse(response, 'Aktif başvuru bilgisi alınamadı.');
        if (!response.ok || !data.ok) throw new Error(data.error || 'İşlemler alınamadı.');
        const active = (data.requests || []).find((request) => request.status === 'awaiting_customer_selection');
        if (!active) return;
        const request = await fetchOperationDetailForDraft(active.id);
        hydrateTradeDraft(request);
        setStatus(`${request.id} aktif takas sepeti yüklendi. Ürün sayfasından eklediğin kartlar burada görünür.`, 'ok');
      }
      async function loadOperationDetail(id, contact = '') {
        const url = new URL(customerApiPath('/trade-draft-api/requests/' + encodeURIComponent(id)), window.location.origin);
        const accessToken = accessTokenForRequest(id);
        const email = TRADE_PROXY_BASE ? '' : String(SHOPIFY_CUSTOMER.email || '').trim();
        if (email) url.searchParams.set('email', email);
        const headers = {};
        if (accessToken) headers['x-kartolog-trade-token'] = accessToken;
        const response = await fetch(url, { headers });
        const data = await response.json();
        if (!response.ok || !data.ok) throw new Error(data.error || 'İşlem detayı alınamadı.');
        renderTracking(data.request);
      }
      async function submitRevisedOfferDecision(id, decision) {
        if (!id) return;
        els.trackingResult.insertAdjacentHTML('afterbegin', '<div class="status" data-decision-status>Karar kaydediliyor...</div>');
        const response = await fetch(customerApiPath(`/trade-draft-api/requests/${encodeURIComponent(id)}/revised-offer/${encodeURIComponent(decision)}`), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ accessToken: accessTokenForRequest(id) }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok) throw new Error(data.error || 'Karar kaydedilemedi.');
        renderTracking(data.request);
      }

      loadCities().catch(() => { els.city.innerHTML = '<option value="">İl listesi yüklenemedi</option>'; });
      loadPokemonSets().catch(() => { if (els.offerSetOptions) els.offerSetOptions.innerHTML = ''; });
      setMode('trade-shipping');
      (async function loadDetailFromPath() {
        const searchParams = new URLSearchParams(window.location.search);
        const match = (searchParams.get('islem') ? ['', searchParams.get('islem')] : window.location.pathname.match(/\/takas-taslak\/islem\/([^/]+)/));
        if (!match) return;
        const id = decodeURIComponent(match[1]);
        const linkToken = searchParams.get('token') || searchParams.get('accessToken') || '';
        if (linkToken) rememberAccessToken(id, linkToken);
        setMode('trade-shipping');
        els.approvedRequestId.value = id;
        els.trackingResult.style.display = 'block';
        els.trackingResult.innerHTML = 'İşlem detayı yükleniyor...';
        try {
          const request = await fetchOperationDetailForDraft(id);
          openOperation(request);
        } catch (error) { els.trackingResult.innerHTML = `<strong>Bulunamadı</strong><p style="margin-top:8px;">${escapeHtml(error.message)}</p>`; }
      })();
      els.modeButtons.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.mode)));
      els.city.addEventListener('change', renderDistricts);
      els.form.elements.phone.addEventListener('input', (event) => { event.target.value = normalizePhone(event.target.value); });
      els.refreshOperations?.addEventListener('click', async () => { els.operationsList.innerHTML = '<div class="empty">İşlemler yükleniyor...</div>'; try { await loadOperations(); } catch (error) { els.operationsList.innerHTML = `<div class="empty">${escapeHtml(error.message)}</div>`; } });
      els.operationsSearch?.addEventListener('input', renderFilteredOperations);
      els.operationsStatusFilter?.addEventListener('change', renderFilteredOperations);
      els.operationsSort?.addEventListener('change', renderFilteredOperations);
      els.operationsList.addEventListener('click', async (event) => {
        const row = event.target.closest('[data-operation-id]');
        if (!row) return;
        els.trackingResult.style.display = 'block';
        els.trackingResult.innerHTML = 'İşlem açılıyor...';
        try {
          const request = await fetchOperationDetailForDraft(row.dataset.operationId);
          history.pushState(null, '', window.location.pathname + '?islem=' + encodeURIComponent(row.dataset.operationId));
          openOperation(request);
        } catch (error) {
          els.trackingResult.innerHTML = `<strong>Bulunamadı</strong><p style="margin-top:8px;">${escapeHtml(error.message)}</p>`;
        }
      });
      els.trackingResult.addEventListener('click', (event) => {
        const decisionButton = event.target.closest('[data-revised-offer-decision]');
        if (decisionButton) {
          submitRevisedOfferDecision(state.lastTrackedRequest?.id, decisionButton.dataset.revisedOfferDecision).catch((error) => {
            const status = document.querySelector('[data-decision-status]');
            if (status) status.textContent = error.message;
            else setStatus(error.message, 'error');
          });
          return;
        }
        const intakeButton = event.target.closest('[data-start-intake]');
        if (intakeButton) {
          startIntakeRequest(state.lastTrackedRequest, intakeButton.dataset.startIntake);
          return;
        }
        const button = event.target.closest('[data-edit-request]');
        if (!button) return;
        editRejectedRequest(state.lastTrackedRequest);
      });
      els.trackingResult.addEventListener('change', async (event) => {
        const target = event.target;
        const frontIndex = target.dataset.reviewPhotoFront;
        const backIndex = target.dataset.reviewPhotoBack;
        if (frontIndex === undefined && backIndex === undefined) return;
        const request = state.lastTrackedRequest;
        const index = Number(frontIndex ?? backIndex);
        const card = request?.offeredCards?.[index];
        if (!request?.id || !card) return;
        try {
          const imageBase64 = await fileToBase64(target.files?.[0]);
          if (!imageBase64) return;
          if (frontIndex !== undefined) {
            card.frontImageBase64 = imageBase64;
            card.photoRefreshFrontUploaded = true;
          }
          if (backIndex !== undefined) {
            card.backImageBase64 = imageBase64;
            card.photoRefreshBackUploaded = true;
          }
          setStatus('Fotoğraf kaydediliyor...', '');
          const updated = await saveOfferedCardsForRequest(request.id, request.offeredCards || []);
          if (updated) {
            state.lastTrackedRequest = updated;
            renderTracking(updated);
          }
          setStatus('Fotoğraf kaydedildi.', 'ok');
        } catch (error) {
          setStatus(error.message || 'Fotoğraf kaydedilemedi.', 'error');
        }
      });
      els.desiredClear.addEventListener('click', () => { state.desiredResults = []; els.desiredSearch.value = ''; els.desiredResults.innerHTML = '<div class="empty">Almak istediğin kartı ara.</div>'; });
      els.offerClear.addEventListener('click', () => { state.offeredResults = []; if (els.offerSetSearch) els.offerSetSearch.value = ''; els.search.value = ''; els.resultCount.textContent = 'Hazır'; els.results.innerHTML = '<div class="empty">Set seçip kart numarası yaz.</div>'; });
      els.desiredForm.addEventListener('submit', async (event) => { event.preventDefault(); const query = els.desiredSearch.value.trim(); if (!query) return; els.desiredResults.innerHTML = '<div class="empty">Stok aranıyor...</div>'; try { state.desiredResults = await fetchStoreCards(query); renderSearchResults(els.desiredResults, state.desiredResults, 'desired-add'); } catch (error) { els.desiredResults.innerHTML = `<div class="empty">${escapeHtml(error.message)}</div>`; } });
      els.searchForm.addEventListener('submit', async (event) => { event.preventDefault(); const setName = (els.offerSetSearch?.value || '').trim(); const number = els.search.value.trim(); if (!setName || !number) { els.results.innerHTML = '<div class="empty">Önce set seç, sonra kart numarası yaz.</div>'; return; } els.results.innerHTML = '<div class="empty">Adaylar aranıyor...</div>'; els.resultCount.textContent = 'Aranıyor'; try { state.offeredResults = await fetchPcCards(number, setName); els.resultCount.textContent = state.offeredResults.length + ' aday'; renderSearchResults(els.results, state.offeredResults, 'offer-add'); } catch (error) { els.results.innerHTML = `<div class="empty">${escapeHtml(error.message)}</div>`; els.resultCount.textContent = 'Hata'; } });
      els.desiredResults.addEventListener('click', async (event) => { const button = event.target.closest('[data-desired-add]'); if (!button) return; const source = state.desiredResults[Number(button.dataset.desiredAdd)]; if (!source) return; const item = await enrichStoreCard(source); const itemLocation = item.locationName || item.inventoryLocations?.[0]?.name || ''; if (state.tradeLocationName && itemLocation && normalizeTradeLocationName(itemLocation) !== normalizeTradeLocationName(state.tradeLocationName)) { setStatus('Bu takas ' + state.tradeLocationName + ' lokasyonuna kilitli. Sadece aynı lokasyondan kart seçebilirsin.', 'error'); return; } if (!state.tradeLocationName && itemLocation) state.tradeLocationName = itemLocation; if (!pcValueTry(item)) { setStatus('Bu kart için fiyat bulunamadı, takas değerine eklenemiyor.', 'error'); return; } state.desired.push({ ...item, _lineId: createLineId('desired'), quantity: 1, condition: 'NM', note: '', estimatedValue: tradeValue({ ...item, quantity: 1 }) }); if (tradeLocationNotice()) setStatus(tradeLocationNotice(), 'ok'); renderDesired(); });
      els.results.addEventListener('click', (event) => { const button = event.target.closest('[data-offer-add]'); if (!button) return; const item = state.offeredResults[Number(button.dataset.offerAdd)]; if (!item) return; const picked = { ...item, productId: item.id, _lineId: createLineId('offered'), quantity: 1, condition: 'NM', note: '', frontImageBase64: '', backImageBase64: '' }; picked.estimatedValue = offerValue(picked); state.offered.push(picked); state.offeredResults = []; els.search.value = ''; els.resultCount.textContent = 'Hazır'; els.results.innerHTML = '<div class="empty">Kart eklendi. Aynı setten yeni numara yazabilirsin.</div>'; renderOffered(); queueOfferedCardsSync(); els.search.focus(); });
      async function removeDesiredCardFromBackend(item, index) {
        if (!TRADE_PROXY_BASE || !state.editingRequestId) return null;
        const response = await fetch(customerApiPath('/trade-draft-api/desired-cards'), {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            requestId: state.editingRequestId,
            lineId: item.lineId || item._lineId || '',
            index,
          }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok) throw new Error(data.error || 'Kart silinemedi.');
        return data.request || null;
      }
      els.desiredPicked.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-desired-remove]');
        if (!button) return;
        const index = Number(button.dataset.desiredRemove);
        const item = state.desired[index];
        if (!item) return;
        button.disabled = true;
        try {
          await removeDesiredCardFromBackend(item, index);
          state.desired.splice(index, 1);
          if (!state.desired.length) state.tradeLocationName = '';
          else state.tradeLocationName = state.desired[0].locationName || state.tradeLocationName;
          renderDesired();
        } catch (error) {
          setStatus(error.message || 'Kart silinemedi.', 'error');
          button.disabled = false;
        }
      });
      els.picked.addEventListener('input', (event) => { const target = event.target; if (target.dataset.note) { state.offered[Number(target.dataset.note)].note = target.value; renderTotals(); saveActiveDraft(); queueOfferedCardsSync(); } });
      els.picked.addEventListener('change', async (event) => { const target = event.target; if (target.dataset.condition) { const item = state.offered[Number(target.dataset.condition)]; item.condition = target.value; item.estimatedValue = offerValue(item); renderOffered(); queueOfferedCardsSync(); return; } if (target.dataset.front) { state.offered[Number(target.dataset.front)].frontImageBase64 = await fileToBase64(target.files?.[0]); renderOffered(); queueOfferedCardsSync(); return; } if (target.dataset.back) { state.offered[Number(target.dataset.back)].backImageBase64 = await fileToBase64(target.files?.[0]); renderOffered(); queueOfferedCardsSync(); } });
      els.picked.addEventListener('click', (event) => { const button = event.target.closest('[data-offer-remove]'); if (!button) return; state.offered.splice(Number(button.dataset.offerRemove), 1); renderOffered(); queueOfferedCardsSync(); });
      els.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (state.mode === 'trade-shipping') {
          state.shippingRequestId = els.approvedRequestId.value.trim();
          if (!state.shippingRequestId) { setStatus('Onaylı başvuru no gerekli.', 'error'); return; }
        }
        if (state.mode !== 'trade-shipping') {
          if (TRADE_PROXY_BASE && !state.editingRequestId) {
            setStatus('Önce Takas başvuru ürününü satın alıp İşlemlerim ekranından başlatmalısın.', 'error');
            els.success.style.display = 'block';
            els.success.innerHTML = `<a href="${escapeHtml(INTAKE_PRODUCT_URL)}">Takas başvuru ürününe git</a>`;
            return;
          }
          if (!state.offered.length) { setStatus('Göndereceğin en az bir kart seçmelisin.', 'error'); return; }
          if (state.offered.some((card) => !sellRule(card).accepted)) { setStatus('Bulk kartlar kabul edilmez.', 'error'); return; }
          if (state.offered.some((card) => !card.frontImageBase64 || !card.backImageBase64)) { setStatus('Her kart için ön ve arka fotoğraf yüklemelisin.', 'error'); return; }
          const total = totals();
          const missing = Math.round(Math.max(0, total.requiredTotal - total.offerTotal) * 100) / 100;
          if (missing > 0) {
            const paymentEstimate = Math.round(missing * VALUE_MULTIPLIER * 100) / 100;
            const approved = window.confirm(`Gönderdiğin kartların tahmini değeri istediğin kartları şu anda ${money(missing)} karşılamıyor.\n\nYine de başvuruyu incelemeye gönderebilirsin. Fiziksel inceleme sonunda açık kalırsa ek ödeme fark x 1.30 olarak hesaplanır.\n\nBu açık için tahmini ek ödeme: ${money(paymentEstimate)}\n\nİncelemeye göndermek istiyor musun?`);
            if (!approved) {
              setStatus('Eksik değer uyarısı onaylanmadığı için başvuru gönderilmedi.', 'error');
              return;
            }
          }
        }
        els.submit.disabled = true;
        els.success.style.display = 'none';
        setStatus(state.editingRequestId ? 'Başvuru tekrar incelemeye gönderiliyor...' : state.mode === 'trade' ? 'Takas başvurusu incelemeye gönderiliyor...' : 'Kargo kodu hazırlanıyor...');
        try {
          const shippingMode = state.mode === 'trade-shipping';
          const shippingContact = shippingMode ? contactPayload(new FormData(els.form)) : null;
          const agreement = shippingMode ? await openShippingAgreementModal(shippingContact, state.shippingRequestId) : null;
          if (shippingMode && !agreement) {
            setStatus('Kargo kodu oluşturmak için anlaşma metnini onaylamalısın.', 'error');
            return;
          }
          const endpoint = shippingMode
            ? customerApiPath(`/trade-draft-api/requests/${encodeURIComponent(state.shippingRequestId)}/shipping`)
            : state.editingRequestId
              ? customerApiPath(`/trade-draft-api/requests/${encodeURIComponent(state.editingRequestId)}/resubmit`)
              : customerApiPath('/trade-draft-api/requests');
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(shippingMode ? { ...shippingContact, agreement, accessToken: accessTokenForRequest(state.shippingRequestId) } : state.editingRequestId ? { ...requestPayload(), accessToken: accessTokenForRequest(state.editingRequestId) } : requestPayload()),
          });
          const data = await response.json();
          if (!response.ok || !data.ok) throw new Error(data.error || 'Başvuru kaydedilemedi.');
          const requestId = data.requestId || state.editingRequestId;
          rememberAccessToken(requestId, data.accessToken || accessTokenForRequest(requestId));
          clearSavedDraft(requestId);
          state.editingRequestId = '';
          setStatus('Başvuru alındı.', 'ok');
          els.success.style.display = 'block';
          els.success.innerHTML = data.needsReview
            ? `Başvuru no: ${escapeHtml(requestId)}<strong>İnceleme bekliyor</strong><p style="margin-top:8px;">${escapeHtml(data.message || 'Kartolog fotoğrafları kontrol ettikten sonra durum güncellenecek.')}</p>`
            : `Başvuru no: ${escapeHtml(requestId)}<strong>${escapeHtml(data.shippingCode)}</strong><p style="margin-top:8px;">Yurtiçi Kargo kodu oluşturuldu. ${escapeHtml(data.message || '')}</p>${data.shippingDeadlineAt ? `<p style="margin-top:8px;">Son gönderim: ${escapeHtml(new Date(data.shippingDeadlineAt).toLocaleString('tr-TR'))}</p>` : ''}`;
          if (!data.needsReview && data.trackingUrl) els.success.insertAdjacentHTML('beforeend', `<p style="margin-top:8px;"><a href="${escapeHtml(data.trackingUrl)}" target="_blank" rel="noreferrer">Kargo takip linki</a></p>`);
        } catch (error) {
          setStatus(error.message, 'error');
        } finally {
          els.submit.disabled = false;
          renderTotals();
        }
      });
})();
